{
    "v": "5.10.2",
    "fr": 50,
    "ip": 0,
    "op": 40,
    "w": 512,
    "h": 512,
    "nm": "loading diamond web",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Small Gear Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 0, "s": [0], "__fnct": [null] },
                        { "i": { "x": [0.728], "y": [0.044] }, "o": { "x": [0.333], "y": [0] }, "t": 6.666, "s": [20], "__fnct": [null] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 20, "s": [51], "__fnct": [null] },
                        { "t": 33.333984375, "s": [80] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [404, 363.798, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [36.781, 36.781, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 12.819],
                                        [-12.819, 7.08],
                                        [-7.08, -12.818],
                                        [12.812, -7.076],
                                        [7.073, 12.807]
                                    ],
                                    "o": [
                                        [-7.08, 12.819],
                                        [-12.819, -7.079],
                                        [7.077, -12.815999999999999],
                                        [12.806, 7.074000000000001],
                                        [0, 12.81]
                                    ],
                                    "v": [
                                        [0, 12.819],
                                        [-12.819, 0],
                                        [0, -12.818],
                                        [12.809, 0.001],
                                        [0, 12.81]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ind": 1,
                            "ty": "sh",
                            "ix": 2,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [6.147, -30.406],
                                        [-4.34, -36.531],
                                        [-6.584, -28.919],
                                        [-11.144, -23.584],
                                        [-15.395, -24.886],
                                        [-17.15, -25.847],
                                        [-28.901, -22.762999999999998],
                                        [-25.104, -15.794],
                                        [-25.003, -7.739],
                                        [-30.406, -6.147],
                                        [-36.531, 4.34],
                                        [-28.919, 6.585],
                                        [-23.584, 11.144],
                                        [-24.886, 15.395],
                                        [-25.848, 17.15],
                                        [-22.762999999999998, 28.901],
                                        [-15.794, 25.104],
                                        [-8.797, 24.557000000000002],
                                        [-6.712999999999999, 28.483],
                                        [-6.147, 30.406],
                                        [4.34, 36.531],
                                        [6.584, 28.919],
                                        [11.144, 23.585],
                                        [15.395, 24.886],
                                        [17.15, 25.848],
                                        [28.901, 22.763],
                                        [25.104, 15.794],
                                        [24.557000000000002, 8.798],
                                        [28.483, 6.713],
                                        [30.406, 6.147],
                                        [36.531, -4.34],
                                        [28.919, -6.584],
                                        [23.584, -11.144000000000002],
                                        [24.886, -15.394],
                                        [25.848, -17.15],
                                        [22.762999999999998, -28.901],
                                        [15.794, -25.104],
                                        [8.797, -24.555999999999997],
                                        [6.712999999999999, -28.482]
                                    ],
                                    "o": [
                                        [4.34, -36.531],
                                        [-6.147, -30.406],
                                        [-7.582999999999999, -25.525],
                                        [-14.974, -24.712],
                                        [-15.794, -25.104],
                                        [-22.762999999999998, -28.901],
                                        [-25.843, -17.154],
                                        [-23.152, -12.206],
                                        [-28.919, -6.584],
                                        [-36.531, -4.34],
                                        [-30.406, 6.147],
                                        [-25.525, 7.584],
                                        [-24.712, 14.974],
                                        [-25.104, 15.794],
                                        [-28.901, 22.762999999999998],
                                        [-17.154, 25.843],
                                        [-12.688, 23.410999999999998],
                                        [-6.8870000000000005, 28.062],
                                        [-6.584, 28.919],
                                        [-4.34, 36.531],
                                        [6.147, 30.406],
                                        [7.582999999999999, 25.526],
                                        [14.974, 24.712],
                                        [15.794, 25.104],
                                        [22.762999999999998, 28.901],
                                        [25.843, 17.155],
                                        [23.410999999999998, 12.688],
                                        [28.062, 6.8870000000000005],
                                        [28.919, 6.585],
                                        [36.531, 4.34],
                                        [30.406, -6.147],
                                        [25.525, -7.582999999999999],
                                        [24.712, -14.973],
                                        [25.104, -15.794],
                                        [28.901, -22.762999999999998],
                                        [17.154, -25.843],
                                        [12.688, -23.410999999999998],
                                        [6.8870000000000005, -28.061],
                                        [6.584, -28.919]
                                    ],
                                    "v": [
                                        [6.147, -30.406],
                                        [-6.147, -30.406],
                                        [-6.584, -28.919],
                                        [-14.538, -24.583],
                                        [-15.794, -25.104],
                                        [-17.15, -25.847],
                                        [-25.843, -17.154],
                                        [-25.104, -15.794],
                                        [-28.919, -6.584],
                                        [-30.406, -6.147],
                                        [-30.406, 6.147],
                                        [-28.919, 6.585],
                                        [-24.583, 14.538],
                                        [-25.104, 15.794],
                                        [-25.848, 17.15],
                                        [-17.154, 25.843],
                                        [-15.794, 25.104],
                                        [-7.105, 27.663],
                                        [-6.584, 28.919],
                                        [-6.147, 30.406],
                                        [6.147, 30.406],
                                        [6.584, 28.919],
                                        [14.538, 24.584],
                                        [15.794, 25.104],
                                        [17.15, 25.848],
                                        [25.843, 17.155],
                                        [25.104, 15.794],
                                        [27.663, 7.105],
                                        [28.919, 6.585],
                                        [30.406, 6.147],
                                        [30.406, -6.147],
                                        [28.919, -6.584],
                                        [24.583, -14.537],
                                        [25.104, -15.794],
                                        [25.848, -17.15],
                                        [17.154, -25.843],
                                        [15.794, -25.104],
                                        [7.105, -27.662],
                                        [6.584, -28.919]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 2",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false, "_render": true },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [36.781, 36.781], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Big Gear Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.647], "y": [0.961] }, "o": { "x": [0.34], "y": [0] }, "t": 0, "s": [0], "__fnct": [null] },
                        {
                            "i": { "x": [0.633], "y": [1.01] },
                            "o": { "x": [0.413], "y": [-0.016] },
                            "t": 6.666,
                            "s": [-20],
                            "__fnct": [null]
                        },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.396], "y": [0.052] }, "t": 20, "s": [-51], "__fnct": [null] },
                        { "t": 33.333984375, "s": [-80] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [338, 409.798, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [52.438, 52.438, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 18.312],
                                        [-18.312, 10.113999999999999],
                                        [-10.114, -18.312],
                                        [18.303, -10.109],
                                        [10.104, 18.296]
                                    ],
                                    "o": [
                                        [-10.114, 18.312],
                                        [-18.312, -10.113000000000001],
                                        [10.11, -18.308],
                                        [18.294, 10.104999999999999],
                                        [0, 18.3]
                                    ],
                                    "v": [
                                        [0, 18.312],
                                        [-18.312, 0.001],
                                        [0, -18.312],
                                        [18.299, 0.001],
                                        [0, 18.3]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ind": 1,
                            "ty": "sh",
                            "ix": 2,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [8.781, -43.438],
                                        [-6.200000000000001, -52.188],
                                        [-9.406, -41.312],
                                        [-15.920000000000002, -33.692],
                                        [-21.992, -35.551],
                                        [-24.5, -36.925],
                                        [-41.288, -32.519000000000005],
                                        [-35.862, -22.562],
                                        [-35.719, -11.056000000000001],
                                        [-43.438, -8.781],
                                        [-52.188, 6.2],
                                        [-41.313, 9.407],
                                        [-33.692, 15.921],
                                        [-35.552, 21.992],
                                        [-36.925, 24.5],
                                        [-32.519, 41.288],
                                        [-22.562, 35.863],
                                        [-12.568000000000001, 35.081],
                                        [-9.59, 40.689],
                                        [-8.781, 43.438],
                                        [6.200000000000001, 52.188],
                                        [9.406, 41.312],
                                        [15.920000000000002, 33.693],
                                        [21.992, 35.552],
                                        [24.5, 36.926],
                                        [41.288, 32.519000000000005],
                                        [35.862, 22.562],
                                        [35.081, 12.568000000000001],
                                        [40.690000000000005, 9.59],
                                        [43.438, 8.782],
                                        [52.188, -6.199000000000001],
                                        [41.313, -9.406],
                                        [33.692, -15.921],
                                        [35.552, -21.992],
                                        [36.925, -24.5],
                                        [32.519, -41.287],
                                        [22.562, -35.862],
                                        [12.568000000000001, -35.081],
                                        [9.59, -40.689]
                                    ],
                                    "o": [
                                        [6.200000000000001, -52.188],
                                        [-8.781, -43.438],
                                        [-10.833, -36.464],
                                        [-21.391000000000002, -35.302],
                                        [-22.562, -35.862],
                                        [-32.519, -41.287],
                                        [-36.919, -24.507],
                                        [-33.075, -17.437],
                                        [-41.313, -9.406],
                                        [-52.188, -6.200000000000001],
                                        [-43.438, 8.782],
                                        [-36.465, 10.834],
                                        [-35.303, 21.391000000000002],
                                        [-35.862, 22.562],
                                        [-41.288, 32.519],
                                        [-24.506, 36.919],
                                        [-18.125, 33.445],
                                        [-9.839, 40.089],
                                        [-9.406, 41.312],
                                        [-6.200000000000001, 52.188],
                                        [8.781, 43.438],
                                        [10.833, 36.464],
                                        [21.391000000000002, 35.303],
                                        [22.562, 35.863],
                                        [32.519, 41.288000000000004],
                                        [36.919, 24.507],
                                        [33.444, 18.125],
                                        [40.088, 9.839],
                                        [41.313, 9.407],
                                        [52.188, 6.2],
                                        [43.438, -8.781],
                                        [36.465, -10.833],
                                        [35.303, -21.391000000000002],
                                        [35.862, -22.562],
                                        [41.288, -32.518],
                                        [24.506, -36.918],
                                        [18.125, -33.444],
                                        [9.839, -40.089],
                                        [9.406, -41.312]
                                    ],
                                    "v": [
                                        [8.781, -43.438],
                                        [-8.781, -43.438],
                                        [-9.406, -41.312],
                                        [-20.768, -35.119],
                                        [-22.562, -35.862],
                                        [-24.5, -36.925],
                                        [-36.919, -24.507],
                                        [-35.862, -22.562],
                                        [-41.313, -9.406],
                                        [-43.438, -8.781],
                                        [-43.438, 8.782],
                                        [-41.313, 9.407],
                                        [-35.119, 20.768],
                                        [-35.862, 22.562],
                                        [-36.925, 24.5],
                                        [-24.506, 36.919],
                                        [-22.562, 35.863],
                                        [-10.15, 39.518],
                                        [-9.406, 41.312],
                                        [-8.781, 43.438],
                                        [8.781, 43.438],
                                        [9.406, 41.312],
                                        [20.768, 35.12],
                                        [22.562, 35.863],
                                        [24.5, 36.926],
                                        [36.919, 24.507],
                                        [35.862, 22.562],
                                        [39.518, 10.15],
                                        [41.313, 9.407],
                                        [43.438, 8.782],
                                        [43.438, -8.781],
                                        [41.313, -9.406],
                                        [35.119, -20.768],
                                        [35.862, -22.562],
                                        [36.925, -24.5],
                                        [24.506, -36.918],
                                        [22.562, -35.862],
                                        [10.15, -39.518],
                                        [9.406, -41.312]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 2",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false, "_render": true },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [52.438, 52.438], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "state 1 check",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 0, "s": [100], "__fnct": [null] },
                        { "t": 10, "s": [0] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 0,
                            "s": [183.867, 135.341, 0],
                            "to": [-0.167, -14, 0],
                            "ti": [0.167, 14, 0],
                            "bezierData": {
                                "segmentLength": 84.00595217162925,
                                "points": [
                                    { "partialLength": 0, "point": [183.867, 135.341, 0] },
                                    { "partialLength": 0.28754967372594326, "point": [183.86357045619505, 135.05347077872122, 0] },
                                    { "partialLength": 0.2987489438414853, "point": [183.86000786378509, 134.75474307765933, 0] },
                                    { "partialLength": 0.30979584293586815, "point": [183.85631403295517, 134.4449692570835, 0] },
                                    { "partialLength": 0.32069037100900133, "point": [183.85249077389045, 134.12430167726288, 0] },
                                    { "partialLength": 0.3314325280607591, "point": [183.8485398967759, 133.79289269846663, 0] },
                                    { "partialLength": 0.3420223140909951, "point": [183.8444632117968, 133.45089468096398, 0] },
                                    { "partialLength": 0.35245972909984036, "point": [183.8402625291381, 133.09845998502396, 0] },
                                    { "partialLength": 0.3627447730870001, "point": [183.83593965898504, 132.73574097091583, 0] },
                                    { "partialLength": 0.37287744605256484, "point": [183.83149641152264, 132.36288999890868, 0] },
                                    { "partialLength": 0.3828577479963717, "point": [183.82693459693604, 131.98005942927176, 0] },
                                    { "partialLength": 0.3926856789185791, "point": [183.8222560254103, 131.5874016222741, 0] },
                                    { "partialLength": 0.4023612388188365, "point": [183.81746250713056, 131.185068938185, 0] },
                                    { "partialLength": 0.411884427697482, "point": [183.8125558522819, 130.77321373727347, 0] },
                                    { "partialLength": 0.42125524555417404, "point": [183.8075378710494, 130.35198837980877, 0] },
                                    { "partialLength": 0.430473692389085, "point": [183.80241037361824, 129.92154522606, 0] },
                                    { "partialLength": 0.4395397682020243, "point": [183.7971751701734, 129.4820366362964, 0] },
                                    { "partialLength": 0.44845347299316657, "point": [183.79183407090017, 129.03361497078706, 0] },
                                    { "partialLength": 0.4572148067623848, "point": [183.7863888859834, 128.5764325898011, 0] },
                                    { "partialLength": 0.46582376950957194, "point": [183.78084142560843, 128.1106418536078, 0] },
                                    { "partialLength": 0.474280361234945, "point": [183.7751934999602, 127.63639512247619, 0] },
                                    { "partialLength": 0.48258458193826037, "point": [183.76944691922392, 127.15384475667551, 0] },
                                    { "partialLength": 0.4907364316196345, "point": [183.7636034935847, 126.6631431164749, 0] },
                                    { "partialLength": 0.49873591027901504, "point": [183.75766503322754, 126.16444256214352, 0] },
                                    { "partialLength": 0.5065830179164474, "point": [183.75163334833758, 125.65789545395049, 0] },
                                    { "partialLength": 0.514277754531851, "point": [183.74551024909996, 125.14365415216498, 0] },
                                    { "partialLength": 0.5218201201252041, "point": [183.7392975456998, 124.62187101705621, 0] },
                                    { "partialLength": 0.529210114696585, "point": [183.7329970483221, 124.09269840889327, 0] },
                                    { "partialLength": 0.536447738245913, "point": [183.72661056715208, 123.55628868794535, 0] },
                                    { "partialLength": 0.5435329907732995, "point": [183.72013991237463, 123.01279421448153, 0] },
                                    { "partialLength": 0.550465872278476, "point": [183.71358689417522, 122.46236734877112, 0] },
                                    { "partialLength": 0.5572463827617861, "point": [183.70695332273863, 121.90516045108312, 0] },
                                    { "partialLength": 0.5638745222229063, "point": [183.7002410082501, 121.34132588168681, 0] },
                                    { "partialLength": 0.5703502906620614, "point": [183.6934517608947, 120.77101600085128, 0] },
                                    { "partialLength": 0.5766736880791183, "point": [183.68658739085762, 120.1943831688457, 0] },
                                    { "partialLength": 0.5828447144741037, "point": [183.6796497083238, 119.61157974593927, 0] },
                                    { "partialLength": 0.5888633698470678, "point": [183.67264052347846, 119.02275809240108, 0] },
                                    { "partialLength": 0.594729654197938, "point": [183.66556164650663, 118.42807056850032, 0] },
                                    { "partialLength": 0.6004435675267523, "point": [183.65841488759347, 117.82766953450613, 0] },
                                    { "partialLength": 0.6060051098334224, "point": [183.65120205692415, 117.22170735068774, 0] },
                                    { "partialLength": 0.6114142811181624, "point": [183.64392496468352, 116.61033637731416, 0] },
                                    { "partialLength": 0.6166710813806505, "point": [183.636585421057, 115.99370897465471, 0] },
                                    { "partialLength": 0.6217755106211891, "point": [183.62918523622943, 115.37197750297842, 0] },
                                    { "partialLength": 0.626727568839544, "point": [183.62172622038608, 114.74529432255456, 0] },
                                    { "partialLength": 0.6315272560358716, "point": [183.614210183712, 114.1138117936522, 0] },
                                    { "partialLength": 0.6361745722100843, "point": [183.6066389363923, 113.47768227654055, 0] },
                                    { "partialLength": 0.6406695173622229, "point": [183.59901428861207, 112.83705813148873, 0] },
                                    { "partialLength": 0.645012091492243, "point": [183.5913380505564, 112.19209171876594, 0] },
                                    { "partialLength": 0.6492022946002283, "point": [183.5836120324104, 111.54293539864126, 0] },
                                    { "partialLength": 0.6532401266860353, "point": [183.57583804435916, 110.88974153138395, 0] },
                                    { "partialLength": 0.6571255877497597, "point": [183.56801789658795, 110.23266247726313, 0] },
                                    { "partialLength": 0.6608586777914923, "point": [183.5601533992815, 109.57185059654788, 0] },
                                    { "partialLength": 0.6644393968109518, "point": [183.55224636262534, 108.9074582495075, 0] },
                                    { "partialLength": 0.6678677448084742, "point": [183.5442985968042, 108.239637796411, 0] },
                                    { "partialLength": 0.671143721783751, "point": [183.5363119120035, 107.56854159752768, 0] },
                                    { "partialLength": 0.6742673277370582, "point": [183.5282881184081, 106.89432201312657, 0] },
                                    { "partialLength": 0.677238562668178, "point": [183.52022902620322, 106.2171314034769, 0] },
                                    { "partialLength": 0.6800574265771948, "point": [183.512136445574, 105.53712212884783, 0] },
                                    { "partialLength": 0.6827239194641384, "point": [183.5040121867054, 104.85444654950848, 0] },
                                    { "partialLength": 0.6852380413289488, "point": [183.49585805978268, 104.16925702572804, 0] },
                                    { "partialLength": 0.6875997921716702, "point": [183.4876758749908, 103.48170591777566, 0] },
                                    { "partialLength": 0.6898091719922708, "point": [183.47946744251502, 102.79194558592049, 0] },
                                    { "partialLength": 0.6918661807908111, "point": [183.4712345725402, 102.10012839043165, 0] },
                                    { "partialLength": 0.6937708185671422, "point": [183.46297907525175, 101.4064066915784, 0] },
                                    { "partialLength": 0.6955230853214831, "point": [183.45470276083455, 100.71093284962977, 0] },
                                    { "partialLength": 0.6971229810535586, "point": [183.44640743947386, 100.01385922485508, 0] },
                                    { "partialLength": 0.6985705057636995, "point": [183.4380949213546, 99.31533817752332, 0] },
                                    { "partialLength": 0.6998656594516461, "point": [183.42976701666197, 98.61552206790371, 0] },
                                    { "partialLength": 0.7010084421174699, "point": [183.4214255355811, 97.91456325626544, 0] },
                                    { "partialLength": 0.7019988537611861, "point": [183.41307228829706, 97.21261410287765, 0] },
                                    { "partialLength": 0.7028368943828218, "point": [183.40470908499495, 96.50982696800948, 0] },
                                    { "partialLength": 0.7035225639823056, "point": [183.3963377358599, 95.80635421193011, 0] },
                                    { "partialLength": 0.7040558625596812, "point": [183.38796005107696, 95.10234819490871, 0] },
                                    { "partialLength": 0.7044367901150331, "point": [183.37957784083122, 94.39796127721435, 0] },
                                    { "partialLength": 0.7046653466481171, "point": [183.37119291530797, 93.69334581911633, 0] },
                                    { "partialLength": 0.7047415321592231, "point": [183.36280708469204, 92.98865418088369, 0] },
                                    { "partialLength": 0.7046653466481462, "point": [183.35442215916873, 92.28403872278564, 0] },
                                    { "partialLength": 0.7044367901149902, "point": [183.34603994892302, 91.57965180509132, 0] },
                                    { "partialLength": 0.7040558625597096, "point": [183.33766226414008, 90.87564578806989, 0] },
                                    { "partialLength": 0.7035225639823195, "point": [183.32929091500506, 90.17217303199051, 0] },
                                    { "partialLength": 0.7028368943828078, "point": [183.32092771170292, 89.46938589712235, 0] },
                                    { "partialLength": 0.7019988537611861, "point": [183.31257446441887, 88.76743674373456, 0] },
                                    { "partialLength": 0.7010084421174704, "point": [183.30423298333798, 88.06647793209629, 0] },
                                    { "partialLength": 0.6998656594516028, "point": [183.2959050786454, 87.36666182247673, 0] },
                                    { "partialLength": 0.6985705057636853, "point": [183.28759256052615, 86.66814077514498, 0] },
                                    { "partialLength": 0.69712298105363, "point": [183.27929723916543, 85.97106715037022, 0] },
                                    { "partialLength": 0.6955230853214547, "point": [183.27102092474823, 85.27559330842162, 0] },
                                    { "partialLength": 0.6937708185671713, "point": [183.26276542745973, 84.58187160956834, 0] },
                                    { "partialLength": 0.6918661807907674, "point": [183.254532557485, 83.89005441407954, 0] },
                                    { "partialLength": 0.6898091719922853, "point": [183.24632412500918, 83.20029408222436, 0] },
                                    { "partialLength": 0.6875997921716557, "point": [183.23814194021733, 82.51274297427199, 0] },
                                    { "partialLength": 0.6852380413289634, "point": [183.22998781329457, 81.82755345049154, 0] },
                                    { "partialLength": 0.682723919464138, "point": [183.22186355442602, 81.14487787115219, 0] },
                                    { "partialLength": 0.6800574265771956, "point": [183.21377097379673, 80.46486859652312, 0] },
                                    { "partialLength": 0.6772385626681776, "point": [183.20571188159187, 79.78767798687345, 0] },
                                    { "partialLength": 0.6742673277370295, "point": [183.1976880879965, 79.11345840247236, 0] },
                                    { "partialLength": 0.6711437217837943, "point": [183.18970140319576, 78.442362203589, 0] },
                                    { "partialLength": 0.6678677448084301, "point": [183.18175363737473, 77.77454175049255, 0] },
                                    { "partialLength": 0.6644393968110104, "point": [183.17384660071843, 77.11014940345211, 0] },
                                    { "partialLength": 0.6608586777914484, "point": [183.1659821034121, 76.4493375227369, 0] },
                                    { "partialLength": 0.6571255877497896, "point": [183.15816195564076, 75.79225846861605, 0] },
                                    { "partialLength": 0.6532401266860346, "point": [183.15038796758958, 75.13906460135874, 0] },
                                    { "partialLength": 0.6492022946002, "point": [183.14266194944358, 74.4899082812341, 0] },
                                    { "partialLength": 0.6450120914922569, "point": [183.13498571138794, 73.84494186851128, 0] },
                                    { "partialLength": 0.6406695173622232, "point": [183.12736106360768, 73.20431772345947, 0] },
                                    { "partialLength": 0.6361745722100843, "point": [183.11978981628798, 72.56818820634781, 0] },
                                    { "partialLength": 0.6315272560358719, "point": [183.11227377961387, 71.93670567744546, 0] },
                                    { "partialLength": 0.6267275688395436, "point": [183.10481476377055, 71.31002249702159, 0] },
                                    { "partialLength": 0.6217755106211744, "point": [183.09741457894302, 70.68829102534532, 0] },
                                    { "partialLength": 0.6166710813806938, "point": [183.09007503531643, 70.07166362268583, 0] },
                                    { "partialLength": 0.6114142811181046, "point": [183.0827979430759, 69.46029264931231, 0] },
                                    { "partialLength": 0.606005109833466, "point": [183.0755851124065, 68.85433046549387, 0] },
                                    { "partialLength": 0.6004435675267382, "point": [183.06843835349332, 68.2539294314997, 0] },
                                    { "partialLength": 0.5947296541979373, "point": [183.06135947652155, 67.65924190759894, 0] },
                                    { "partialLength": 0.5888633698470536, "point": [183.0543502916762, 67.07042025406076, 0] },
                                    { "partialLength": 0.5828447144741321, "point": [183.04741260914238, 66.4876168311543, 0] },
                                    { "partialLength": 0.5766736880791332, "point": [183.04054823910525, 65.91098399914871, 0] },
                                    { "partialLength": 0.5703502906620476, "point": [183.03375899174983, 65.34067411831319, 0] },
                                    { "partialLength": 0.5638745222229057, "point": [183.02704667726135, 64.77683954891688, 0] },
                                    { "partialLength": 0.5572463827617575, "point": [183.02041310582476, 64.2196326512289, 0] },
                                    { "partialLength": 0.5504658722785052, "point": [183.0138600876253, 63.66920578551847, 0] },
                                    { "partialLength": 0.5435329907732485, "point": [183.00738943284796, 63.1257113120547, 0] },
                                    { "partialLength": 0.536447738245935, "point": [183.0010029516779, 62.58930159110676, 0] },
                                    { "partialLength": 0.5292101146965914, "point": [182.99470245430024, 62.060128982943816, 0] },
                                    { "partialLength": 0.5218201201252264, "point": [182.9884897509, 61.53834584783502, 0] },
                                    { "partialLength": 0.5142777545318293, "point": [182.9823666516624, 61.024104546049536, 0] },
                                    { "partialLength": 0.5065830179164403, "point": [182.97633496677244, 60.51755743785651, 0] },
                                    { "partialLength": 0.49873591027904346, "point": [182.97039650641528, 60.0188568835251, 0] },
                                    { "partialLength": 0.4907364316196348, "point": [182.96455308077603, 59.52815524332449, 0] },
                                    { "partialLength": 0.48258458193826037, "point": [182.95880650003974, 59.045604877523814, 0] },
                                    { "partialLength": 0.47428036123491624, "point": [182.95315857439155, 58.57135814639223, 0] },
                                    { "partialLength": 0.46582376950961496, "point": [182.94761111401655, 58.10556741019889, 0] },
                                    { "partialLength": 0.45721480676234827, "point": [182.94216592909987, 57.64838502921297, 0] },
                                    { "partialLength": 0.44845347299316013, "point": [182.93682482982658, 57.19996336370362, 0] },
                                    { "partialLength": 0.4395397682020592, "point": [182.9315896263818, 56.76045477393999, 0] },
                                    { "partialLength": 0.4304736923890647, "point": [182.92646212895056, 56.33001162019124, 0] },
                                    { "partialLength": 0.4212552455541734, "point": [182.92144414771812, 55.90878626272655, 0] },
                                    { "partialLength": 0.4118844276974536, "point": [182.91653749286945, 55.49693106181505, 0] },
                                    { "partialLength": 0.40236123881890073, "point": [182.91174397458968, 55.094598377725895, 0] },
                                    { "partialLength": 0.3926856789185293, "point": [182.90706540306394, 54.70194057072827, 0] },
                                    { "partialLength": 0.3828577479964001, "point": [182.90250358847734, 54.31911000109132, 0] },
                                    { "partialLength": 0.372877446052551, "point": [182.8980603410149, 53.94625902908419, 0] },
                                    { "partialLength": 0.3627447730870004, "point": [182.89373747086182, 53.58354001497605, 0] },
                                    { "partialLength": 0.35245972909981094, "point": [182.8895367882032, 53.23110531903606, 0] },
                                    { "partialLength": 0.3420223140910455, "point": [182.88546010322406, 52.889107301533365, 0] },
                                    { "partialLength": 0.33143252806073675, "point": [182.88150922610959, 52.55769832273714, 0] },
                                    { "partialLength": 0.3206903710089878, "point": [182.8776859670448, 52.23703074291653, 0] },
                                    { "partialLength": 0.30979584293586815, "point": [182.8739921362149, 51.9272569223407, 0] },
                                    { "partialLength": 0.2987489438414924, "point": [182.87042954380493, 51.628529221278804, 0] },
                                    { "partialLength": 0.28754967372595747, "point": [182.867, 51.341, 0] }
                                ]
                            }
                        },
                        { "t": 20, "s": [182.867, 51.341, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [48.133, 41.138, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 0,
                                "s": [
                                    {
                                        "i": [
                                            [310.267, -12.202],
                                            [-11.733, -12.202],
                                            [-11.733, 389.798],
                                            [310.267, 389.798]
                                        ],
                                        "o": [
                                            [310.267, -12.202],
                                            [-11.733, -12.202],
                                            [-11.733, 389.798],
                                            [310.267, 389.798]
                                        ],
                                        "v": [
                                            [310.267, -12.202],
                                            [-11.733, -12.202],
                                            [-11.733, 389.798],
                                            [310.267, 389.798]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 20,
                                "s": [
                                    {
                                        "i": [
                                            [310.267, 67.798],
                                            [-11.733, 67.798],
                                            [-11.733, 469.798],
                                            [310.267, 469.798]
                                        ],
                                        "o": [
                                            [310.267, 67.798],
                                            [-11.733, 67.798],
                                            [-11.733, 469.798],
                                            [310.267, 469.798]
                                        ],
                                        "v": [
                                            [310.267, 67.798],
                                            [-11.733, 67.798],
                                            [-11.733, 469.798],
                                            [310.267, 469.798]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ],
                        "ix": 1
                    },
                    "o": { "a": 0, "k": 100, "ix": 3 },
                    "x": { "a": 0, "k": 0, "ix": 4 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "o": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "v": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 12, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [48.133, 41.139], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "list 1 ",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [100], "__fnct": [null] },
                        { "t": 10, "s": [1] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 0,
                            "s": [309.5, 137.202, 0],
                            "to": [-0.167, -13.667, 0],
                            "ti": [0.167, 13.667, 0],
                            "bezierData": {
                                "segmentLength": 82.00609733584265,
                                "points": [
                                    { "partialLength": 0, "point": [309.5, 137.202, 0] },
                                    { "partialLength": 0.280710815083455, "point": [309.49657045619506, 136.9213101356762, 0] },
                                    { "partialLength": 0.2916432073924853, "point": [309.4930078637851, 136.62968868867085, 0] },
                                    { "partialLength": 0.3024268596709895, "point": [309.48931403295524, 136.32728438799995, 0] },
                                    { "partialLength": 0.31306177191879303, "point": [309.48549077389043, 136.01424596267958, 0] },
                                    { "partialLength": 0.3235479441357082, "point": [309.481539896776, 135.6907221417259, 0] },
                                    { "partialLength": 0.33388537632182463, "point": [309.4774632117968, 135.3568616541549, 0] },
                                    { "partialLength": 0.3440740684769528, "point": [309.4732625291381, 135.01281322898268, 0] },
                                    { "partialLength": 0.3541140206010576, "point": [309.468939658985, 134.65872559522532, 0] },
                                    { "partialLength": 0.36400523269411494, "point": [309.4644964115226, 134.29474748189887, 0] },
                                    { "partialLength": 0.3737477047559045, "point": [309.4599345969361, 133.92102761801954, 0] },
                                    { "partialLength": 0.38334143678675836, "point": [309.45525602541034, 133.53771473260318, 0] },
                                    { "partialLength": 0.3927864287862385, "point": [309.4504625071305, 133.14495755466604, 0] },
                                    { "partialLength": 0.40208268075450937, "point": [309.4455558522819, 132.74290481322416, 0] },
                                    { "partialLength": 0.41123019269157707, "point": [309.4405378710494, 132.33170523729356, 0] },
                                    { "partialLength": 0.42022896459729614, "point": [309.43541037361825, 131.91150755589038, 0] },
                                    { "partialLength": 0.429078996471734, "point": [309.4301751701734, 131.48246049803066, 0] },
                                    { "partialLength": 0.43778028831480853, "point": [309.4248340709002, 131.0447127927305, 0] },
                                    { "partialLength": 0.4463328401266222, "point": [309.4193888859834, 130.5984131690059, 0] },
                                    { "partialLength": 0.4547366519069222, "point": [309.41384142560844, 130.14371035587308, 0] },
                                    { "partialLength": 0.46299172365595703, "point": [309.40819349996025, 129.680753082348, 0] },
                                    { "partialLength": 0.4710980553735394, "point": [309.40244691922396, 129.20969007744677, 0] },
                                    { "partialLength": 0.47905564705971454, "point": [309.3966034935847, 128.73067007018548, 0] },
                                    { "partialLength": 0.48686449871449994, "point": [309.3906650332275, 128.2438417895802, 0] },
                                    { "partialLength": 0.49452461033781375, "point": [309.38463334833756, 127.749353964647, 0] },
                                    { "partialLength": 0.5020359819297902, "point": [309.3785102490999, 127.2473553244019, 0] },
                                    { "partialLength": 0.5093986134901489, "point": [309.3722975456998, 126.73799459786112, 0] },
                                    { "partialLength": 0.5166125050192126, "point": [309.3659970483221, 126.22142051404059, 0] },
                                    { "partialLength": 0.5236776565167417, "point": [309.3596105671521, 125.69778180195645, 0] },
                                    { "partialLength": 0.5305940679828648, "point": [309.3531399123747, 125.16722719062473, 0] },
                                    { "partialLength": 0.5373617394173672, "point": [309.3465868941753, 124.62990540906164, 0] },
                                    { "partialLength": 0.5439806708205529, "point": [309.3399533227386, 124.08596518628309, 0] },
                                    { "partialLength": 0.5504508621921791, "point": [309.3332410082501, 123.53555525130524, 0] },
                                    { "partialLength": 0.5567723135322913, "point": [309.3264517608947, 122.97882433314419, 0] },
                                    { "partialLength": 0.5629450248409662, "point": [309.3195873908576, 122.41592116081596, 0] },
                                    { "partialLength": 0.5689689961181018, "point": [309.3126497083238, 121.84699446333666, 0] },
                                    { "partialLength": 0.5748442273637796, "point": [309.30564052347853, 121.27219296972233, 0] },
                                    { "partialLength": 0.580570718577913, "point": [309.29856164650664, 120.69166540898908, 0] },
                                    { "partialLength": 0.5861484697605934, "point": [309.2914148875935, 120.10556051015294, 0] },
                                    { "partialLength": 0.5915774809116499, "point": [309.28420205692413, 119.5140270022301, 0] },
                                    { "partialLength": 0.5968577520313377, "point": [309.27692496468353, 118.91721361423647, 0] },
                                    { "partialLength": 0.6019892831193645, "point": [309.26958542105706, 118.3152690751883, 0] },
                                    { "partialLength": 0.6069720741760196, "point": [309.26218523622947, 117.7083421141015, 0] },
                                    { "partialLength": 0.611806125201038, "point": [309.2547262203861, 117.09658145999227, 0] },
                                    { "partialLength": 0.6164914361945768, "point": [309.247210183712, 116.48013584187663, 0] },
                                    { "partialLength": 0.6210280071565766, "point": [309.2396389363924, 115.85915398877069, 0] },
                                    { "partialLength": 0.6254158380870677, "point": [309.23201428861205, 115.23378462969049, 0] },
                                    { "partialLength": 0.6296549289860411, "point": [309.2243380505564, 114.6041764936521, 0] },
                                    { "partialLength": 0.6337452798534595, "point": [309.21661203241035, 113.97047830967163, 0] },
                                    { "partialLength": 0.6376868906893869, "point": [309.2088380443592, 113.33283880676511, 0] },
                                    { "partialLength": 0.6414797614936405, "point": [309.201017896588, 112.69140671394875, 0] },
                                    { "partialLength": 0.645123892266592, "point": [309.19315339928147, 112.0463307602384, 0] },
                                    { "partialLength": 0.6486192830077878, "point": [309.1852463626254, 111.39775967465036, 0] },
                                    { "partialLength": 0.6519659337175832, "point": [309.1772985968042, 110.74584218620056, 0] },
                                    { "partialLength": 0.6551638443957493, "point": [309.16931191200354, 110.09072702390517, 0] },
                                    { "partialLength": 0.6582130150424957, "point": [309.16128811840815, 109.43256291678016, 0] },
                                    { "partialLength": 0.6611134456576168, "point": [309.15322902620323, 108.77149859384167, 0] },
                                    { "partialLength": 0.6638651362411823, "point": [309.145136445574, 108.1076827841058, 0] },
                                    { "partialLength": 0.6664680867932654, "point": [309.1370121867054, 107.44126421658858, 0] },
                                    { "partialLength": 0.6689222973137637, "point": [309.12885805978266, 106.77239162030611, 0] },
                                    { "partialLength": 0.6712277678027201, "point": [309.1206758749908, 106.10121372427447, 0] },
                                    { "partialLength": 0.6733844982601466, "point": [309.1124674425151, 105.42787925750973, 0] },
                                    { "partialLength": 0.6753924886860772, "point": [309.1042345725402, 104.75253694902791, 0] },
                                    { "partialLength": 0.6772517390803433, "point": [309.09597907525176, 104.07533552784521, 0] },
                                    { "partialLength": 0.6789622494431838, "point": [309.08770276083453, 103.39642372297759, 0] },
                                    { "partialLength": 0.68052401977439, "point": [309.0794074394739, 102.7159502634412, 0] },
                                    { "partialLength": 0.681937050074127, "point": [309.07109492135464, 102.03406387825206, 0] },
                                    { "partialLength": 0.6832013403422597, "point": [309.06276701666195, 101.35091329642628, 0] },
                                    { "partialLength": 0.6843168905788876, "point": [309.05442553558106, 100.66664724697992, 0] },
                                    { "partialLength": 0.6852837007839119, "point": [309.0460722882971, 99.9814144589291, 0] },
                                    { "partialLength": 0.6861017709574496, "point": [309.037709084995, 99.29536366128983, 0] },
                                    { "partialLength": 0.6867711010994257, "point": [309.0293377358599, 98.6086435830782, 0] },
                                    { "partialLength": 0.6872916912098099, "point": [309.02096005107705, 97.92140295331035, 0] },
                                    { "partialLength": 0.6876635412887372, "point": [309.0125778408312, 97.23379050100225, 0] },
                                    { "partialLength": 0.6878866513359557, "point": [309.00419291530795, 96.54595495517013, 0] },
                                    { "partialLength": 0.6879610213518298, "point": [308.99580708469205, 95.85804504482988, 0] },
                                    { "partialLength": 0.687886651335999, "point": [308.9874221591687, 95.17020949899772, 0] },
                                    { "partialLength": 0.6876635412887067, "point": [308.97903994892306, 94.48259704668965, 0] },
                                    { "partialLength": 0.6872916912098255, "point": [308.9706622641401, 93.79535641692178, 0] },
                                    { "partialLength": 0.6867711010994109, "point": [308.96229091500504, 93.10863633871017, 0] },
                                    { "partialLength": 0.6861017709574354, "point": [308.95392771170293, 92.42258554107092, 0] },
                                    { "partialLength": 0.6852837007839275, "point": [308.9455744644189, 91.73735275302008, 0] },
                                    { "partialLength": 0.6843168905788735, "point": [308.937232983338, 91.05308670357373, 0] },
                                    { "partialLength": 0.6832013403422724, "point": [308.9289050786454, 90.36993612174794, 0] },
                                    { "partialLength": 0.6819370500740979, "point": [308.9205925605262, 89.68804973655882, 0] },
                                    { "partialLength": 0.6805240197744064, "point": [308.9122972391654, 89.00757627702242, 0] },
                                    { "partialLength": 0.6789622494432115, "point": [308.90402092474824, 88.32866447215477, 0] },
                                    { "partialLength": 0.677251739080359, "point": [308.8957654274597, 87.65146305097205, 0] },
                                    { "partialLength": 0.6753924886860317, "point": [308.88753255748503, 86.97612074249028, 0] },
                                    { "partialLength": 0.6733844982601621, "point": [308.8793241250092, 86.30278627572552, 0] },
                                    { "partialLength": 0.6712277678027201, "point": [308.87114194021734, 85.63160837969389, 0] },
                                    { "partialLength": 0.6689222973137786, "point": [308.8629878132945, 84.9627357834114, 0] },
                                    { "partialLength": 0.6664680867932363, "point": [308.854863554426, 84.2963172158942, 0] },
                                    { "partialLength": 0.6638651362412107, "point": [308.84677097379677, 83.63250140615831, 0] },
                                    { "partialLength": 0.6611134456576025, "point": [308.83871188159185, 82.97143708321984, 0] },
                                    { "partialLength": 0.6582130150424667, "point": [308.8306880879965, 82.31327297609485, 0] },
                                    { "partialLength": 0.6551638443957932, "point": [308.82270140319577, 81.65815781379942, 0] },
                                    { "partialLength": 0.6519659337175526, "point": [308.81475363737474, 81.00624032534965, 0] },
                                    { "partialLength": 0.6486192830078467, "point": [308.8068466007185, 80.35766923976155, 0] },
                                    { "partialLength": 0.645123892266533, "point": [308.79898210341213, 79.71259328605126, 0] },
                                    { "partialLength": 0.6414797614936993, "point": [308.79116195564075, 79.07116119323484, 0] },
                                    { "partialLength": 0.6376868906893591, "point": [308.78338796758953, 78.43352169032835, 0] },
                                    { "partialLength": 0.633745279853444, "point": [308.7756619494436, 77.79982350634789, 0] },
                                    { "partialLength": 0.6296549289860411, "point": [308.76798571138795, 77.1702153703095, 0] },
                                    { "partialLength": 0.6254158380870664, "point": [308.7603610636077, 76.54484601122931, 0] },
                                    { "partialLength": 0.6210280071565779, "point": [308.752789816288, 75.92386415812337, 0] },
                                    { "partialLength": 0.616491436194591, "point": [308.7452737796139, 75.30741854000772, 0] },
                                    { "partialLength": 0.6118061252010238, "point": [308.73781476377053, 74.6956578858985, 0] },
                                    { "partialLength": 0.6069720741759904, "point": [308.730414578943, 74.08873092481173, 0] },
                                    { "partialLength": 0.601989283119422, "point": [308.72307503531647, 73.4867863857635, 0] },
                                    { "partialLength": 0.5968577520312944, "point": [308.7157979430759, 72.88997299776992, 0] },
                                    { "partialLength": 0.5915774809116933, "point": [308.7085851124065, 72.29843948984703, 0] },
                                    { "partialLength": 0.5861484697605507, "point": [308.70143835349336, 71.71233459101093, 0] },
                                    { "partialLength": 0.5805707185779266, "point": [308.6943594765215, 71.13180703027767, 0] },
                                    { "partialLength": 0.5748442273637655, "point": [308.68735029167624, 70.55700553666335, 0] },
                                    { "partialLength": 0.5689689961181167, "point": [308.6804126091424, 69.98807883918404, 0] },
                                    { "partialLength": 0.5629450248409669, "point": [308.67354823910523, 69.42517566685581, 0] },
                                    { "partialLength": 0.5567723135323197, "point": [308.6667589917498, 68.86844474869473, 0] },
                                    { "partialLength": 0.5504508621921507, "point": [308.66004667726133, 68.3180348137169, 0] },
                                    { "partialLength": 0.5439806708205372, "point": [308.65341310582477, 67.77409459093838, 0] },
                                    { "partialLength": 0.5373617394174105, "point": [308.6468600876253, 67.23677280937524, 0] },
                                    { "partialLength": 0.5305940679828208, "point": [308.640389432848, 66.70621819804356, 0] },
                                    { "partialLength": 0.5236776565167438, "point": [308.63400295167787, 66.18257948595942, 0] },
                                    { "partialLength": 0.5166125050191976, "point": [308.6277024543002, 65.66600540213891, 0] },
                                    { "partialLength": 0.5093986134902072, "point": [308.62148975089997, 65.15664467559807, 0] },
                                    { "partialLength": 0.5020359819297185, "point": [308.6153666516624, 64.65464603535304, 0] },
                                    { "partialLength": 0.4945246103378564, "point": [308.60933496677245, 64.16015821041981, 0] },
                                    { "partialLength": 0.48686449871449994, "point": [308.60339650641527, 63.673329929814514, 0] },
                                    { "partialLength": 0.4790556470597281, "point": [308.59755308077604, 63.19430992255322, 0] },
                                    { "partialLength": 0.4710980553735394, "point": [308.59180650003975, 62.72324691765199, 0] },
                                    { "partialLength": 0.4629917236559357, "point": [308.58615857439156, 62.26028964412692, 0] },
                                    { "partialLength": 0.45473665190695134, "point": [308.58061111401656, 61.805586830994066, 0] },
                                    { "partialLength": 0.4463328401265711, "point": [308.57516592909985, 61.35928720726952, 0] },
                                    { "partialLength": 0.43778028831482346, "point": [308.5698248298266, 60.92153950196935, 0] },
                                    { "partialLength": 0.4290789964717333, "point": [308.5645896263818, 60.49249244410963, 0] },
                                    { "partialLength": 0.420228964597311, "point": [308.5594621289506, 60.072294762706434, 0] },
                                    { "partialLength": 0.41123019269156214, "point": [308.55444414771813, 59.66109518677585, 0] },
                                    { "partialLength": 0.4020826807545314, "point": [308.5495374928695, 59.259042445333954, 0] },
                                    { "partialLength": 0.3927864287862456, "point": [308.54474397458966, 58.866285267396805, 0] },
                                    { "partialLength": 0.38334143678670085, "point": [308.540065403064, 58.4829723819805, 0] },
                                    { "partialLength": 0.37374770475597696, "point": [308.53550358847735, 58.1092525181011, 0] },
                                    { "partialLength": 0.3640052326940801, "point": [308.5310603410149, 57.74527440477468, 0] },
                                    { "partialLength": 0.35411402060105696, "point": [308.52673747086186, 57.391186771017324, 0] },
                                    { "partialLength": 0.34407406847694505, "point": [308.5225367882032, 57.04713834584511, 0] },
                                    { "partialLength": 0.3338853763218239, "point": [308.5184601032241, 56.71327785827411, 0] },
                                    { "partialLength": 0.32354794413573734, "point": [308.51450922610957, 56.3897540373204, 0] },
                                    { "partialLength": 0.31306177191876394, "point": [308.5106859670448, 56.07671561200006, 0] },
                                    { "partialLength": 0.3024268596709824, "point": [308.50699213621493, 55.774311311329164, 0] },
                                    { "partialLength": 0.2916432073925144, "point": [308.50342954380494, 55.48268986432378, 0] },
                                    { "partialLength": 0.2807108150834479, "point": [308.5, 55.202, 0] }
                                ]
                            }
                        },
                        { "t": 20, "s": [308.5, 55.202, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [86.75, 15.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 0,
                                "s": [
                                    {
                                        "i": [
                                            [219.25, -43.952],
                                            [-102.75, -43.952],
                                            [-102.75, 344.048],
                                            [219.25, 344.048]
                                        ],
                                        "o": [
                                            [219.25, -43.952],
                                            [-102.75, -43.952],
                                            [-102.75, 344.048],
                                            [219.25, 344.048]
                                        ],
                                        "v": [
                                            [219.25, -43.952],
                                            [-102.75, -43.952],
                                            [-102.75, 344.048],
                                            [219.25, 344.048]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 20,
                                "s": [
                                    {
                                        "i": [
                                            [219.25, 40.048],
                                            [-102.75, 40.048],
                                            [-102.75, 428.048],
                                            [219.25, 428.048]
                                        ],
                                        "o": [
                                            [219.25, 40.048],
                                            [-102.75, 40.048],
                                            [-102.75, 428.048],
                                            [219.25, 428.048]
                                        ],
                                        "v": [
                                            [219.25, 40.048],
                                            [-102.75, 40.048],
                                            [-102.75, 428.048],
                                            [219.25, 428.048]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ],
                        "ix": 1
                    },
                    "o": { "a": 0, "k": 100, "ix": 3 },
                    "x": { "a": 0, "k": 0, "ix": 4 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [80.451, 15],
                                        [-72.99, 15],
                                        [-86.5, 8.951],
                                        [-86.5, -1.49],
                                        [-80.451, -15],
                                        [72.99, -15],
                                        [86.5, -8.951],
                                        [86.5, 1.49]
                                    ],
                                    "o": [
                                        [72.99, 15],
                                        [-80.451, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -8.951],
                                        [-72.99, -15],
                                        [80.451, -15],
                                        [86.5, -1.49],
                                        [86.5, 8.951]
                                    ],
                                    "v": [
                                        [72.99, 15],
                                        [-72.99, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -1.49],
                                        [-72.99, -15],
                                        [72.99, -15],
                                        [86.5, -1.49],
                                        [86.5, 1.49]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [86.75, 15.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "state 2 bullet",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [100], "__fnct": [null] },
                        { "t": 13.333984375, "s": [0] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [179.53, 205.202, 0],
                            "to": [-0.167, -10.167, 0],
                            "ti": [0.167, 10.167, 0],
                            "bezierData": {
                                "segmentLength": 61.00819617275612,
                                "points": [
                                    { "partialLength": 0, "point": [179.53, 205.202, 0] },
                                    { "partialLength": 0.20883572124507024, "point": [179.5265704561951, 204.99319244099593, 0] },
                                    { "partialLength": 0.2169687723093007, "point": [179.5230078637851, 204.77625291925605, 0] },
                                    { "partialLength": 0.22499116961873664, "point": [179.51931403295518, 204.5512920737291, 0] },
                                    { "partialLength": 0.23290291317305162, "point": [179.51549077389043, 204.3184205433639, 0] },
                                    { "partialLength": 0.24070400297228373, "point": [179.51153989677593, 204.07774896710924, 0] },
                                    { "partialLength": 0.2483944390161761, "point": [179.50746321179682, 203.82938798391393, 0] },
                                    { "partialLength": 0.2559742213048328, "point": [179.5032625291381, 203.57344823272663, 0] },
                                    { "partialLength": 0.26344334983782475, "point": [179.49893965898508, 203.31004035249634, 0] },
                                    { "partialLength": 0.27080182461542524, "point": [179.49449641152268, 203.03927498217172, 0] },
                                    { "partialLength": 0.27804964563739715, "point": [179.48993459693605, 202.76126276070158, 0] },
                                    { "partialLength": 0.28518681290382797, "point": [179.4852560254103, 202.47611432703462, 0] },
                                    { "partialLength": 0.29221332641438424, "point": [179.48046250713057, 202.1839403201198, 0] },
                                    { "partialLength": 0.29912918616933637, "point": [179.4755558522819, 201.88485137890578, 0] },
                                    { "partialLength": 0.30593439216847473, "point": [179.47053787104943, 201.57895814234138, 0] },
                                    { "partialLength": 0.31262894441179473, "point": [179.46541037361823, 201.2663712493754, 0] },
                                    { "partialLength": 0.31921284289929314, "point": [179.46017517017344, 200.9472013389566, 0] },
                                    { "partialLength": 0.32568608763097256, "point": [179.45483407090015, 200.62155905003374, 0] },
                                    { "partialLength": 0.33204867860672355, "point": [179.4493888859834, 200.28955502155563, 0] },
                                    { "partialLength": 0.3383006158264938, "point": [179.4438414256084, 199.95129989247113, 0] },
                                    { "partialLength": 0.34444189929040714, "point": [179.43819349996025, 199.60690430172895, 0] },
                                    { "partialLength": 0.3504725289983618, "point": [179.43244691922393, 199.25647888827788, 0] },
                                    { "partialLength": 0.35639250495030983, "point": [179.42660349358468, 198.90013429106676, 0] },
                                    { "partialLength": 0.36220182714635263, "point": [179.42066503322755, 198.5379811490443, 0] },
                                    { "partialLength": 0.3679004955863062, "point": [179.41463334833762, 198.17013010115937, 0] },
                                    { "partialLength": 0.3734885102703568, "point": [179.40851024909998, 197.79669178636067, 0] },
                                    { "partialLength": 0.3789658711982933, "point": [179.40229754569978, 197.41777684359707, 0] },
                                    { "partialLength": 0.38433257837027696, "point": [179.39599704832213, 197.03349591181728, 0] },
                                    { "partialLength": 0.3895886317861857, "point": [179.38961056715206, 196.64395962997014, 0] },
                                    { "partialLength": 0.3947340314461519, "point": [179.38313991237467, 196.24927863700432, 0] },
                                    { "partialLength": 0.3997687773498239, "point": [179.37658689417523, 195.84956357186886, 0] },
                                    { "partialLength": 0.4046928694976839, "point": [179.3699533227386, 195.44492507351228, 0] },
                                    { "partialLength": 0.4095063078893204, "point": [179.3632410082501, 195.03547378088354, 0] },
                                    { "partialLength": 0.414209092524959, "point": [179.3564517608947, 194.62132033293133, 0] },
                                    { "partialLength": 0.4188012234044213, "point": [179.3495873908576, 194.20257536860456, 0] },
                                    { "partialLength": 0.4232827005279598, "point": [179.3426497083238, 193.77934952685183, 0] },
                                    { "partialLength": 0.42765352389528266, "point": [179.33564052347845, 193.35175344662207, 0] },
                                    { "partialLength": 0.4319136935065572, "point": [179.32856164650667, 192.919897766864, 0] },
                                    { "partialLength": 0.43606320936175197, "point": [179.32141488759348, 192.48389312652643, 0] },
                                    { "partialLength": 0.44010207146074576, "point": [179.3142020569241, 192.0438501645582, 0] },
                                    { "partialLength": 0.4440302798038236, "point": [179.3069249646835, 191.59987951990792, 0] },
                                    { "partialLength": 0.4478478343905207, "point": [179.29958542105703, 191.15209183152464, 0] },
                                    { "partialLength": 0.45155473522138423, "point": [179.29218523622941, 190.7005977383569, 0] },
                                    { "partialLength": 0.45515098229594475, "point": [179.2847262203861, 190.24550787935362, 0] },
                                    { "partialLength": 0.4586365756144063, "point": [179.27721018371201, 189.78693289346361, 0] },
                                    { "partialLength": 0.46201151517684824, "point": [179.26963893639234, 189.32498341963554, 0] },
                                    { "partialLength": 0.46527580098307153, "point": [179.26201428861208, 188.8597700968183, 0] },
                                    { "partialLength": 0.46842943303318474, "point": [179.2543380505564, 188.39140356396064, 0] },
                                    { "partialLength": 0.47147241132724454, "point": [179.2466120324104, 187.91999446001128, 0] },
                                    { "partialLength": 0.47440473586504933, "point": [179.23883804435917, 187.44565342391914, 0] },
                                    { "partialLength": 0.47722640664670923, "point": [179.2310178965879, 186.968491094633, 0] },
                                    { "partialLength": 0.4799374236724828, "point": [179.22315339928153, 186.48861811110143, 0] },
                                    { "partialLength": 0.4825377869417941, "point": [179.21524636262535, 186.00614511227351, 0] },
                                    { "partialLength": 0.4850274964552174, "point": [179.2072985968042, 185.5211827370978, 0] },
                                    { "partialLength": 0.48740655221231516, "point": [179.19931191200354, 185.03384162452326, 0] },
                                    { "partialLength": 0.4896749542134099, "point": [179.1912881184081, 184.54423241349855, 0] },
                                    { "partialLength": 0.491832702458348, "point": [179.18322902620326, 184.05246574297246, 0] },
                                    { "partialLength": 0.4938797969470505, "point": [179.17513644557397, 183.55865225189388, 0] },
                                    { "partialLength": 0.49581623767971067, "point": [179.16701218670542, 183.06290257921148, 0] },
                                    { "partialLength": 0.4976420246561882, "point": [179.15885805978266, 182.5653273638741, 0] },
                                    { "partialLength": 0.4993571578764802, "point": [179.15067587499084, 182.06603724483057, 0] },
                                    { "partialLength": 0.5009616373406727, "point": [179.14246744251503, 181.5651428610296, 0] },
                                    { "partialLength": 0.5024554630487656, "point": [179.13423457254024, 181.06275485141998, 0] },
                                    { "partialLength": 0.5038386350005545, "point": [179.1259790752518, 180.5589838549506, 0] },
                                    { "partialLength": 0.5051111531963868, "point": [179.11770276083456, 180.0539405105701, 0] },
                                    { "partialLength": 0.5062730176358284, "point": [179.10940743947387, 179.54773545722747, 0] },
                                    { "partialLength": 0.5073242283193974, "point": [179.10109492135462, 179.04047933387125, 0] },
                                    { "partialLength": 0.5082647852466621, "point": [179.09276701666198, 178.53228277945036, 0] },
                                    { "partialLength": 0.5090946884178221, "point": [179.0844255355811, 178.02325643291354, 0] },
                                    { "partialLength": 0.5098139378327634, "point": [179.07607228829707, 177.51351093320966, 0] },
                                    { "partialLength": 0.5104225334916007, "point": [179.06770908499496, 177.00315691928745, 0] },
                                    { "partialLength": 0.5109204753943034, "point": [179.0593377358599, 176.49230503009568, 0] },
                                    { "partialLength": 0.511307763540788, "point": [179.05096005107697, 175.9810659045832, 0] },
                                    { "partialLength": 0.5115843979312802, "point": [179.04257784083126, 175.46955018169865, 0] },
                                    { "partialLength": 0.5117503785653811, "point": [179.03419291530795, 174.95786850039104, 0] },
                                    { "partialLength": 0.5118057054435491, "point": [179.02580708469202, 174.44613149960895, 0] },
                                    { "partialLength": 0.5117503785654379, "point": [179.01742215916872, 173.9344498183013, 0] },
                                    { "partialLength": 0.5115843979311945, "point": [179.00903994892303, 173.42293409541682, 0] },
                                    { "partialLength": 0.5113077635408444, "point": [179.00066226414012, 172.9116949699043, 0] },
                                    { "partialLength": 0.510920475394275, "point": [178.99229091500507, 172.40084308071255, 0] },
                                    { "partialLength": 0.5104225334916296, "point": [178.98392771170293, 171.8904890667903, 0] },
                                    { "partialLength": 0.5098139378327634, "point": [178.9755744644189, 171.38074356708643, 0] },
                                    { "partialLength": 0.5090946884177937, "point": [178.96723298333802, 170.87171722054964, 0] },
                                    { "partialLength": 0.5082647852466332, "point": [178.95890507864542, 170.36352066612878, 0] },
                                    { "partialLength": 0.5073242283193684, "point": [178.9505925605262, 169.85626454277258, 0] },
                                    { "partialLength": 0.5062730176359151, "point": [178.9422972391654, 169.35005948942987, 0] },
                                    { "partialLength": 0.505111153196329, "point": [178.93402092474824, 168.8450161450494, 0] },
                                    { "partialLength": 0.5038386350006411, "point": [178.9257654274597, 168.34124514857996, 0] },
                                    { "partialLength": 0.5024554630486786, "point": [178.91753255748503, 167.8388571389704, 0] },
                                    { "partialLength": 0.5009616373407015, "point": [178.9093241250092, 167.33796275516943, 0] },
                                    { "partialLength": 0.49935715787648066, "point": [178.90114194021734, 166.8386726361259, 0] },
                                    { "partialLength": 0.4976420246561886, "point": [178.89298781329455, 166.34109742078851, 0] },
                                    { "partialLength": 0.4958162376796533, "point": [178.88486355442603, 165.84534774810618, 0] },
                                    { "partialLength": 0.49387979694707845, "point": [178.87677097379677, 165.35153425702757, 0] },
                                    { "partialLength": 0.49183270245832045, "point": [178.86871188159188, 164.8597675865015, 0] },
                                    { "partialLength": 0.4896749542134374, "point": [178.8606880879965, 164.37015837547676, 0] },
                                    { "partialLength": 0.4874065522123441, "point": [178.8527014031958, 163.8828172629022, 0] },
                                    { "partialLength": 0.48502749645515963, "point": [178.8447536373747, 163.39785488772654, 0] },
                                    { "partialLength": 0.4825377869418804, "point": [178.83684660071847, 162.91538188889854, 0] },
                                    { "partialLength": 0.4799374236723976, "point": [178.8289821034121, 162.43550890536704, 0] },
                                    { "partialLength": 0.47722640664679544, "point": [178.82116195564078, 161.95834657608083, 0] },
                                    { "partialLength": 0.4744047358650773, "point": [178.81338796758956, 161.48400553998866, 0] },
                                    { "partialLength": 0.4714724113271872, "point": [178.8056619494436, 161.01259643603936, 0] },
                                    { "partialLength": 0.4684294330331843, "point": [178.79798571138795, 160.5442299031817, 0] },
                                    { "partialLength": 0.46527580098307153, "point": [178.7903610636077, 160.07901658036445, 0] },
                                    { "partialLength": 0.4620115151768203, "point": [178.782789816288, 159.6170671065364, 0] },
                                    { "partialLength": 0.4586365756144347, "point": [178.7752737796139, 159.15849212064637, 0] },
                                    { "partialLength": 0.45515098229594525, "point": [178.76781476377056, 158.7034022616431, 0] },
                                    { "partialLength": 0.4515547352213544, "point": [178.76041457894303, 158.25190816847538, 0] },
                                    { "partialLength": 0.4478478343905794, "point": [178.75307503531644, 157.80412048009205, 0] },
                                    { "partialLength": 0.4440302798037658, "point": [178.7457979430759, 157.36014983544183, 0] },
                                    { "partialLength": 0.4401020714607742, "point": [178.73858511240653, 156.92010687347357, 0] },
                                    { "partialLength": 0.4360632093617515, "point": [178.73143835349336, 156.48410223313599, 0] },
                                    { "partialLength": 0.43191369350655767, "point": [178.72435947652156, 156.05224655337793, 0] },
                                    { "partialLength": 0.42765352389528266, "point": [178.7173502916762, 155.62465047314817, 0] },
                                    { "partialLength": 0.4232827005279314, "point": [178.7104126091424, 155.20142463139547, 0] },
                                    { "partialLength": 0.418801223404507, "point": [178.70354823910526, 154.7826796670686, 0] },
                                    { "partialLength": 0.4142090925249311, "point": [178.69675899174985, 154.36852621911643, 0] },
                                    { "partialLength": 0.4095063078893199, "point": [178.69004667726136, 153.9590749264877, 0] },
                                    { "partialLength": 0.40469286949768296, "point": [178.6834131058248, 153.5544364281311, 0] },
                                    { "partialLength": 0.3997687773498532, "point": [178.6768600876253, 153.15472136299562, 0] },
                                    { "partialLength": 0.3947340314460373, "point": [178.67038943284797, 152.7600403700299, 0] },
                                    { "partialLength": 0.3895886317862136, "point": [178.66400295167793, 152.37050408818274, 0] },
                                    { "partialLength": 0.38433257837027746, "point": [178.65770245430025, 151.98622315640296, 0] },
                                    { "partialLength": 0.37896587119832265, "point": [178.6514897509, 151.60730821363933, 0] },
                                    { "partialLength": 0.3734885102703274, "point": [178.6453666516624, 151.23386989884065, 0] },
                                    { "partialLength": 0.36790049558636345, "point": [178.63933496677245, 150.86601885095567, 0] },
                                    { "partialLength": 0.3622018271463247, "point": [178.6333965064153, 150.50386570893323, 0] },
                                    { "partialLength": 0.35639250495033825, "point": [178.62755308077604, 150.14752111172209, 0] },
                                    { "partialLength": 0.3504725289983329, "point": [178.62180650003975, 149.79709569827105, 0] },
                                    { "partialLength": 0.3444418992904076, "point": [178.61615857439156, 149.45270010752887, 0] },
                                    { "partialLength": 0.3383006158265222, "point": [178.61061111401656, 149.11444497844434, 0] },
                                    { "partialLength": 0.33204867860666576, "point": [178.60516592909988, 148.7824409499663, 0] },
                                    { "partialLength": 0.32568608763097256, "point": [178.5998248298266, 148.45679866104342, 0] },
                                    { "partialLength": 0.3192128428992936, "point": [178.59458962638178, 148.13762875062463, 0] },
                                    { "partialLength": 0.3126289444118227, "point": [178.5894621289506, 147.82504185765862, 0] },
                                    { "partialLength": 0.30593439216844676, "point": [178.5844441477181, 147.51914862109425, 0] },
                                    { "partialLength": 0.29912918616936435, "point": [178.57953749286946, 147.2200596798802, 0] },
                                    { "partialLength": 0.2922133264144416, "point": [178.5747439745897, 146.92788567296532, 0] },
                                    { "partialLength": 0.28518681290374226, "point": [178.57006540306398, 146.64273723929844, 0] },
                                    { "partialLength": 0.2780496456374545, "point": [178.56550358847733, 146.36472501782825, 0] },
                                    { "partialLength": 0.27080182461539637, "point": [178.56106034101495, 146.09395964750365, 0] },
                                    { "partialLength": 0.263443349837883, "point": [178.55673747086183, 145.8305517672733, 0] },
                                    { "partialLength": 0.2559742213047461, "point": [178.5525367882032, 145.5746120160861, 0] },
                                    { "partialLength": 0.24839443901617658, "point": [178.54846010322407, 145.32625103289078, 0] },
                                    { "partialLength": 0.24070400297228325, "point": [178.5445092261096, 145.0855794566361, 0] },
                                    { "partialLength": 0.23290291317305212, "point": [178.54068596704482, 144.85270792627094, 0] },
                                    { "partialLength": 0.22499116961873664, "point": [178.5369921362149, 144.62774708074397, 0] },
                                    { "partialLength": 0.21696877230930023, "point": [178.53342954380494, 144.4108075590041, 0] },
                                    { "partialLength": 0.20883572124509914, "point": [178.53, 144.202, 0] }
                                ]
                            }
                        },
                        { "t": 20, "s": [178.53, 144.202, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [17.014, 17.015, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 34,
                    "nm": "Puppet",
                    "np": 6,
                    "mn": "ADBE FreePin3",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        { "ty": 7, "nm": "Puppet Engine", "mn": "ADBE FreePin3 Puppet Engine", "ix": 1, "v": { "a": 0, "k": 2, "ix": 1 } },
                        {
                            "ty": 0,
                            "nm": "Mesh Rotation Refinement",
                            "mn": "ADBE FreePin3 Auto Rotate Pins",
                            "ix": 2,
                            "v": { "a": 0, "k": 20, "ix": 2 }
                        },
                        {
                            "ty": 7,
                            "nm": "On Transparent",
                            "mn": "ADBE FreePin3 On Transparent",
                            "ix": 3,
                            "v": { "a": 0, "k": 0, "ix": 3 }
                        },
                        {
                            "ty": "",
                            "nm": "arap",
                            "np": 3,
                            "mn": "ADBE FreePin3 ARAP Group",
                            "ix": 4,
                            "en": 1,
                            "ef": [
                                { "ty": 6, "nm": "Auto-traced Shapes", "mn": "ADBE FreePin3 Outlines", "ix": 1, "v": 0 },
                                { "ty": "", "nm": "Mesh", "np": 1, "mn": "ADBE FreePin3 Mesh Group", "ix": 2, "en": 1, "ef": [] }
                            ]
                        }
                    ]
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [16.765, -9.259],
                                        [9.258000000000001, 16.765],
                                        [-16.765, 9.259],
                                        [-9.26, -16.765]
                                    ],
                                    "o": [
                                        [16.765, 9.259],
                                        [-9.26, 16.765],
                                        [-16.765, -9.259],
                                        [9.258000000000001, -16.765]
                                    ],
                                    "v": [
                                        [16.765, 0],
                                        [-0.001, 16.765],
                                        [-16.765, 0],
                                        [-0.001, -16.765]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.5412, 0.8353, 0.7608, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [17.014, 17.015], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 4 },
                    "o": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.833], "y": [0.833] },
                                "o": { "x": [0.167], "y": [0.167] },
                                "t": 0,
                                "s": [0],
                                "__fnct": [null]
                            },
                            { "t": 20, "s": [100] }
                        ],
                        "ix": 5
                    },
                    "r": 2,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "state 2 check",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0], "__fnct": [null] },
                        { "t": 20, "s": [100] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [183.867, 139.341, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [48.133, 41.138, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "o": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "v": [
                                        [-18.133, 0.455],
                                        [-4.103, 11.139],
                                        [18.133, -11.139]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 12, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [48.133, 41.139], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.833], "y": [0.833] },
                                "o": { "x": [0.167], "y": [0.167] },
                                "t": 23.334,
                                "s": [0],
                                "__fnct": [null]
                            },
                            { "t": 33.333984375, "s": [79] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "list 2 ",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [309.5, 204.202, 0],
                            "to": null,
                            "ti": null
                        },
                        { "t": 20, "s": [309.5, 141.202, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [86.75, 15.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 3.334,
                                        "s": [
                                            {
                                                "i": [
                                                    [-64.549, 14.5],
                                                    [-72.99, 15],
                                                    [-86.5, 8.951],
                                                    [-86.5, -1.49],
                                                    [-80.451, -15],
                                                    [-72.01, -15.5],
                                                    [-58.5, -9.451],
                                                    [-58.5, 0.99]
                                                ],
                                                "o": [
                                                    [-72.01, 14.5],
                                                    [-80.451, 15],
                                                    [-86.5, 1.49],
                                                    [-86.5, -8.951],
                                                    [-72.99, -15],
                                                    [-64.549, -15.5],
                                                    [-58.5, -1.99],
                                                    [-58.5, 8.451]
                                                ],
                                                "v": [
                                                    [-72.01, 14.5],
                                                    [-72.99, 15],
                                                    [-86.5, 1.49],
                                                    [-86.5, -1.49],
                                                    [-72.99, -15],
                                                    [-72.01, -15.5],
                                                    [-58.5, -1.99],
                                                    [-58.5, 0.99]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [78.951, 15],
                                                    [-72.99, 15],
                                                    [-86.5, 8.951],
                                                    [-86.5, -1.49],
                                                    [-80.451, -15],
                                                    [71.49, -15],
                                                    [85, -8.951],
                                                    [85, 1.49]
                                                ],
                                                "o": [
                                                    [71.49, 15],
                                                    [-80.451, 15],
                                                    [-86.5, 1.49],
                                                    [-86.5, -8.951],
                                                    [-72.99, -15],
                                                    [78.951, -15],
                                                    [85, -1.49],
                                                    [85, 8.951]
                                                ],
                                                "v": [
                                                    [71.49, 15],
                                                    [-72.99, 15],
                                                    [-86.5, 1.49],
                                                    [-86.5, -1.49],
                                                    [-72.99, -15],
                                                    [71.49, -15],
                                                    [85, -1.49],
                                                    [85, 1.49]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [86.75, 15.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 4 },
                    "o": {
                        "a": 1,
                        "k": [
                            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0], "__fnct": [null] },
                            { "t": 13.333984375, "s": [100] }
                        ],
                        "ix": 5
                    },
                    "r": 2,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "state 3 Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [179.53, 271.437, 0],
                            "to": [0.167, -10.333, 0],
                            "ti": [-0.167, 10.333, 0],
                            "bezierData": {
                                "segmentLength": 62.00806399389156,
                                "points": [
                                    { "partialLength": 0, "point": [179.53, 271.437, 0] },
                                    { "partialLength": 0.21224508195651093, "point": [179.53342954380494, 271.22478262784585, 0] },
                                    { "partialLength": 0.2205119638951926, "point": [179.53699213621493, 271.0042994444594, 0] },
                                    { "partialLength": 0.22866637125069605, "point": [179.54068596704485, 270.7756629098575, 0] },
                                    { "partialLength": 0.23670830402319895, "point": [179.54450922610965, 270.53898548405675, 0] },
                                    { "partialLength": 0.24463776221221747, "point": [179.5484601032241, 270.2943796270741, 0] },
                                    { "partialLength": 0.2524547458178077, "point": [179.55253678820324, 270.0419577989262, 0] },
                                    { "partialLength": 0.26015925483991975, "point": [179.55673747086183, 269.7818324596298, 0] },
                                    { "partialLength": 0.2677512892782996, "point": [179.56106034101492, 269.51411606920175, 0] },
                                    { "partialLength": 0.2752308491329245, "point": [179.56550358847736, 269.2389210876588, 0] },
                                    { "partialLength": 0.28259793440378417, "point": [179.57006540306395, 268.95635997501773, 0] },
                                    { "partialLength": 0.28985254509082253, "point": [179.57474397458967, 268.66654519129526, 0] },
                                    { "partialLength": 0.2969946811938748, "point": [179.57953749286946, 268.36958919650823, 0] },
                                    { "partialLength": 0.30402434271317746, "point": [179.58444414771816, 268.0656044506732, 0] },
                                    { "partialLength": 0.3109415296482936, "point": [179.58946212895063, 267.7547034138072, 0] },
                                    { "partialLength": 0.31774624199941526, "point": [179.59458962638178, 267.4369985459269, 0] },
                                    { "partialLength": 0.3244384797666262, "point": [179.59982482982662, 267.1126023070489, 0] },
                                    { "partialLength": 0.3310182429495528, "point": [179.6051659290999, 266.78162715719026, 0] },
                                    { "partialLength": 0.3374855315486833, "point": [179.61061111401656, 266.44418555636736, 0] },
                                    { "partialLength": 0.34384034556325727, "point": [179.61615857439156, 266.1003899645974, 0] },
                                    { "partialLength": 0.3500826849939905, "point": [179.62180650003975, 265.75035284189687, 0] },
                                    { "partialLength": 0.35621254984040995, "point": [179.627553080776, 265.39418664828264, 0] },
                                    { "partialLength": 0.3622299401026705, "point": [179.6333965064153, 265.03200384377146, 0] },
                                    { "partialLength": 0.36813485578075544, "point": [179.63933496677248, 264.6639168883801, 0] },
                                    { "partialLength": 0.37392729687459325, "point": [179.6453666516624, 264.29003824212526, 0] },
                                    { "partialLength": 0.37960726338422923, "point": [179.65148975090003, 263.9104803650238, 0] },
                                    { "partialLength": 0.38517475530959505, "point": [179.65770245430025, 263.5253557170924, 0] },
                                    { "partialLength": 0.3906297726507352, "point": [179.66400295167793, 263.13477675834787, 0] },
                                    { "partialLength": 0.39597231540752753, "point": [179.670389432848, 262.73885594880704, 0] },
                                    { "partialLength": 0.40120238358035853, "point": [179.67686008762524, 262.33770574848637, 0] },
                                    { "partialLength": 0.4063199771684302, "point": [179.68341310582483, 261.9314386174031, 0] },
                                    { "partialLength": 0.4113250961725777, "point": [179.6900466772613, 261.52016701557363, 0] },
                                    { "partialLength": 0.4162177405922351, "point": [179.69675899174985, 261.10400340301493, 0] },
                                    { "partialLength": 0.4209979104276182, "point": [179.7035482391053, 260.6830602397437, 0] },
                                    { "partialLength": 0.42566560567883327, "point": [179.7104126091424, 260.25744998577665, 0] },
                                    { "partialLength": 0.43022082634553815, "point": [179.7173502916762, 259.82728510113066, 0] },
                                    { "partialLength": 0.4346635724281219, "point": [179.72435947652156, 259.3926780458223, 0] },
                                    { "partialLength": 0.4389938439261836, "point": [179.73143835349336, 258.9537412798686, 0] },
                                    { "partialLength": 0.44321164084017206, "point": [179.73858511240647, 258.510587263286, 0] },
                                    { "partialLength": 0.44731696316946157, "point": [179.74579794307596, 258.0633284560917, 0] },
                                    { "partialLength": 0.4513098109147793, "point": [179.7530750353164, 257.61207731830206, 0] },
                                    { "partialLength": 0.4551901840755064, "point": [179.76041457894306, 257.1569463099341, 0] },
                                    { "partialLength": 0.458958082652142, "point": [179.76781476377053, 256.6980478910043, 0] },
                                    { "partialLength": 0.46261350664412093, "point": [179.77527377961388, 256.2354945215298, 0] },
                                    { "partialLength": 0.46615645605197786, "point": [179.78278981628802, 255.7693986615271, 0] },
                                    { "partialLength": 0.46958693087533926, "point": [179.79036106360775, 255.29987277101313, 0] },
                                    { "partialLength": 0.47290493111448767, "point": [179.79798571138795, 254.8270293100045, 0] },
                                    { "partialLength": 0.47611045676919467, "point": [179.8056619494436, 254.35098073851805, 0] },
                                    { "partialLength": 0.47920350783959925, "point": [179.81338796758956, 253.8718395165705, 0] },
                                    { "partialLength": 0.48218408432558507, "point": [179.82116195564075, 253.38971810417868, 0] },
                                    { "partialLength": 0.4850521862270957, "point": [179.82898210341216, 252.90472896135947, 0] },
                                    { "partialLength": 0.4878078135445208, "point": [179.83684660071842, 252.41698454812934, 0] },
                                    { "partialLength": 0.49045096627729984, "point": [179.84475363737474, 251.92659732450534, 0] },
                                    { "partialLength": 0.49298164442596104, "point": [179.8527014031957, 251.43367975050398, 0] },
                                    { "partialLength": 0.4953998479900016, "point": [179.86068808799655, 250.9383442861423, 0] },
                                    { "partialLength": 0.49770557696989354, "point": [179.86871188159188, 250.4407033914368, 0] },
                                    { "partialLength": 0.49989883136530183, "point": [179.87677097379677, 249.9408695264044, 0] },
                                    { "partialLength": 0.5019796111763064, "point": [179.88486355442603, 249.4389551510619, 0] },
                                    { "partialLength": 0.503947916402993, "point": [179.89298781329458, 248.93507272542595, 0] },
                                    { "partialLength": 0.5058037470453038, "point": [179.90114194021734, 248.42933470951337, 0] },
                                    { "partialLength": 0.5075471031032089, "point": [179.9093241250092, 247.92185356334093, 0] },
                                    { "partialLength": 0.5091779845767365, "point": [179.91753255748506, 247.4127417469254, 0] },
                                    { "partialLength": 0.5106963914659968, "point": [179.9257654274597, 246.90211172028344, 0] },
                                    { "partialLength": 0.5121023237706539, "point": [179.93402092474827, 246.39007594343204, 0] },
                                    { "partialLength": 0.5133957814911546, "point": [179.9422972391654, 245.87674687638773, 0] },
                                    { "partialLength": 0.5145767646270216, "point": [179.95059256052622, 245.36223697916753, 0] },
                                    { "partialLength": 0.5156452731788456, "point": [179.95890507864542, 244.84665871178788, 0] },
                                    { "partialLength": 0.5166013071460333, "point": [179.967232983338, 244.3301245342658, 0] },
                                    { "partialLength": 0.5174448665289249, "point": [179.9755744644189, 243.81274690661795, 0] },
                                    { "partialLength": 0.5181759513273743, "point": [179.9839277117029, 243.29463828886117, 0] },
                                    { "partialLength": 0.5187945615415287, "point": [179.99229091500504, 242.77591114101213, 0] },
                                    { "partialLength": 0.5193006971712129, "point": [180.00066226414012, 242.2566779230877, 0] },
                                    { "partialLength": 0.5196943582165707, "point": [180.00903994892306, 241.73705109510456, 0] },
                                    { "partialLength": 0.5199755446776004, "point": [180.0174221591687, 241.21714311707944, 0] },
                                    { "partialLength": 0.5201442565540217, "point": [180.02580708469208, 240.69706644902934, 0] },
                                    { "partialLength": 0.5202004938463974, "point": [180.03419291530795, 240.17693355097066, 0] },
                                    { "partialLength": 0.5201442565540777, "point": [180.04257784083129, 239.6568568829205, 0] },
                                    { "partialLength": 0.5199755446775156, "point": [180.05096005107694, 239.13694890489546, 0] },
                                    { "partialLength": 0.5196943582165707, "point": [180.05933773585988, 238.61732207691233, 0] },
                                    { "partialLength": 0.5193006971712696, "point": [180.06770908499496, 238.09808885898784, 0] },
                                    { "partialLength": 0.5187945615414998, "point": [180.07607228829707, 237.57936171113883, 0] },
                                    { "partialLength": 0.5181759513273747, "point": [180.0844255355811, 237.06125309338205, 0] },
                                    { "partialLength": 0.5174448665289244, "point": [180.09276701666198, 236.5438754657342, 0] },
                                    { "partialLength": 0.5166013071460057, "point": [180.10109492135462, 236.02734128821214, 0] },
                                    { "partialLength": 0.5156452731787603, "point": [180.1094074394738, 235.51176302083257, 0] },
                                    { "partialLength": 0.5145767646271637, "point": [180.11770276083462, 234.99725312361224, 0] },
                                    { "partialLength": 0.5133957814911267, "point": [180.1259790752518, 234.48392405656796, 0] },
                                    { "partialLength": 0.512102323770681, "point": [180.13423457254027, 233.97188827971652, 0] },
                                    { "partialLength": 0.510696391465913, "point": [180.142467442515, 233.46125825307465, 0] },
                                    { "partialLength": 0.5091779845767929, "point": [180.15067587499084, 232.95214643665906, 0] },
                                    { "partialLength": 0.5075471031032084, "point": [180.15885805978266, 232.44466529048663, 0] },
                                    { "partialLength": 0.5058037470453038, "point": [180.16701218670542, 231.93892727457404, 0] },
                                    { "partialLength": 0.503947916402993, "point": [180.17513644557397, 231.4350448489381, 0] },
                                    { "partialLength": 0.501979611176307, "point": [180.18322902620326, 230.93313047359558, 0] },
                                    { "partialLength": 0.4998988313653014, "point": [180.19128811840812, 230.43329660856318, 0] },
                                    { "partialLength": 0.49770557696986556, "point": [180.19931191200348, 229.93565571385773, 0] },
                                    { "partialLength": 0.49539984799005704, "point": [180.20729859680424, 229.44032024949598, 0] },
                                    { "partialLength": 0.49298164442584874, "point": [180.2152463626253, 228.94740267549474, 0] },
                                    { "partialLength": 0.49045096627738416, "point": [180.22315339928156, 228.45701545187066, 0] },
                                    { "partialLength": 0.4878078135445217, "point": [180.23101789658787, 227.96927103864053, 0] },
                                    { "partialLength": 0.4850521862271512, "point": [180.2388380443592, 227.48428189582125, 0] },
                                    { "partialLength": 0.4821840843255571, "point": [180.2466120324104, 227.00216048342946, 0] },
                                    { "partialLength": 0.4792035078395424, "point": [180.25433805055638, 226.52301926148198, 0] },
                                    { "partialLength": 0.4761104567691956, "point": [180.26201428861208, 226.04697068999553, 0] },
                                    { "partialLength": 0.4729049311144597, "point": [180.2696389363923, 225.57412722898692, 0] },
                                    { "partialLength": 0.4695869308753961, "point": [180.27721018371204, 225.1046013384729, 0] },
                                    { "partialLength": 0.46615645605194855, "point": [180.28472622038612, 224.63850547847022, 0] },
                                    { "partialLength": 0.4626135066441773, "point": [180.29218523622944, 224.17595210899566, 0] },
                                    { "partialLength": 0.45895808265202925, "point": [180.29958542105697, 223.717053690066, 0] },
                                    { "partialLength": 0.45519018407559075, "point": [180.30692496468356, 223.26192268169794, 0] },
                                    { "partialLength": 0.4513098109147238, "point": [180.3142020569241, 222.81067154390834, 0] },
                                    { "partialLength": 0.44731696316957387, "point": [180.3214148875935, 222.3634127367139, 0] },
                                    { "partialLength": 0.4432116408400873, "point": [180.32856164650664, 221.92025872013141, 0] },
                                    { "partialLength": 0.43899384392624047, "point": [180.33564052347845, 221.48132195417764, 0] },
                                    { "partialLength": 0.4346635724280651, "point": [180.3426497083238, 221.04671489886937, 0] },
                                    { "partialLength": 0.4302208263455666, "point": [180.3495873908576, 220.61655001422335, 0] },
                                    { "partialLength": 0.42566560567880535, "point": [180.35645176089474, 220.1909397602563, 0] },
                                    { "partialLength": 0.4209979104276737, "point": [180.3632410082501, 219.76999659698504, 0] },
                                    { "partialLength": 0.4162177405922351, "point": [180.36995332273864, 219.35383298442633, 0] },
                                    { "partialLength": 0.41132509617255064, "point": [180.3765868941752, 218.9425613825969, 0] },
                                    { "partialLength": 0.4063199771685141, "point": [180.3831399123747, 218.53629425151354, 0] },
                                    { "partialLength": 0.40120238358018945, "point": [180.38961056715203, 218.13514405119304, 0] },
                                    { "partialLength": 0.3959723154075844, "point": [180.3959970483221, 217.73922324165216, 0] },
                                    { "partialLength": 0.39062977265073473, "point": [180.40229754569975, 217.34864428290763, 0] },
                                    { "partialLength": 0.3851747553096514, "point": [180.40851024909995, 216.9635196349762, 0] },
                                    { "partialLength": 0.3796072633841734, "point": [180.41463334833762, 216.58396175787476, 0] },
                                    { "partialLength": 0.3739272968746496, "point": [180.42066503322752, 216.2100831116199, 0] },
                                    { "partialLength": 0.368134855780727, "point": [180.4266034935847, 215.84199615622853, 0] },
                                    { "partialLength": 0.36222994010267007, "point": [180.43244691922396, 215.47981335171735, 0] },
                                    { "partialLength": 0.3562125498404104, "point": [180.43819349996025, 215.12364715810313, 0] },
                                    { "partialLength": 0.35008268499396206, "point": [180.44384142560844, 214.7736100354026, 0] },
                                    { "partialLength": 0.3438403455633136, "point": [180.4493888859834, 214.4298144436326, 0] },
                                    { "partialLength": 0.3374855315485142, "point": [180.45483407090015, 214.09237284280988, 0] },
                                    { "partialLength": 0.3310182429496376, "point": [180.46017517017341, 213.76139769295114, 0] },
                                    { "partialLength": 0.3244384797665969, "point": [180.4654103736182, 213.4370014540732, 0] },
                                    { "partialLength": 0.317746241999473, "point": [180.4705378710494, 213.11929658619283, 0] },
                                    { "partialLength": 0.310941529648294, "point": [180.4755558522819, 212.8083955493268, 0] },
                                    { "partialLength": 0.3040243427131202, "point": [180.48046250713057, 212.50441080349185, 0] },
                                    { "partialLength": 0.2969946811939591, "point": [180.4852560254103, 212.20745480870474, 0] },
                                    { "partialLength": 0.28985254509079456, "point": [180.48993459693605, 211.9176400249823, 0] },
                                    { "partialLength": 0.28259793440384146, "point": [180.49449641152268, 211.63507891234116, 0] },
                                    { "partialLength": 0.275230849132924, "point": [180.49893965898508, 211.35988393079822, 0] },
                                    { "partialLength": 0.26775128927827074, "point": [180.50326252913814, 211.09216754037018, 0] },
                                    { "partialLength": 0.26015925483986385, "point": [180.5074632117968, 210.83204220107385, 0] },
                                    { "partialLength": 0.25245474581783567, "point": [180.5115398967759, 210.57962037292594, 0] },
                                    { "partialLength": 0.2446377622122184, "point": [180.5154907738904, 210.33501451594327, 0] },
                                    { "partialLength": 0.2367083040231696, "point": [180.51931403295515, 210.09833709014256, 0] },
                                    { "partialLength": 0.22866637125072492, "point": [180.5230078637851, 209.86970055554065, 0] },
                                    { "partialLength": 0.22051196389519212, "point": [180.52657045619506, 209.64921737215417, 0] },
                                    { "partialLength": 0.21224508195651093, "point": [180.53, 209.437, 0] }
                                ]
                            }
                        },
                        { "t": 20, "s": [180.53, 209.437, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [17.014, 17.015, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [16.765, -9.259],
                                        [9.258000000000001, 16.765],
                                        [-16.765, 9.259],
                                        [-9.26, -16.765]
                                    ],
                                    "o": [
                                        [16.765, 9.259],
                                        [-9.26, 16.765],
                                        [-16.765, -9.259],
                                        [9.258000000000001, -16.765]
                                    ],
                                    "v": [
                                        [16.765, 0],
                                        [-0.001, 16.765],
                                        [-16.765, 0],
                                        [-0.001, -16.765]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.5412, 0.8353, 0.7608, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [17.014, 17.015], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "list 3",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 0,
                            "s": [309.5, 271.202, 0],
                            "to": [0.167, -10.5, 0],
                            "ti": [-0.167, 10.5, 0],
                            "bezierData": {
                                "segmentLength": 63.007936010172756,
                                "points": [
                                    { "partialLength": 0, "point": [309.5, 271.202, 0] },
                                    { "partialLength": 0.21567418513438374, "point": [309.50342954380494, 270.9863530840409, 0] },
                                    { "partialLength": 0.2240740987193087, "point": [309.50699213621493, 270.76230730824454, 0] },
                                    { "partialLength": 0.23235972776691996, "point": [309.51068596704494, 270.52997694281265, 0] },
                                    { "partialLength": 0.24053107227682868, "point": [309.5145092261096, 270.2894762579472, 0] },
                                    { "partialLength": 0.2485881322489659, "point": [309.51846010322413, 270.04091952385, 0] },
                                    { "partialLength": 0.25653090768321274, "point": [309.52253678820324, 269.784421010723, 0] },
                                    { "partialLength": 0.2643593985796442, "point": [309.52673747086186, 269.52009498876794, 0] },
                                    { "partialLength": 0.2720736049378921, "point": [309.5310603410149, 269.2480557281868, 0] },
                                    { "partialLength": 0.27967352675788465, "point": [309.5355035884773, 268.96841749918156, 0] },
                                    { "partialLength": 0.287159164040012, "point": [309.540065403064, 268.6812945719538, 0] },
                                    { "partialLength": 0.29453051678376124, "point": [309.54474397458966, 268.3868012167055, 0] },
                                    { "partialLength": 0.3017875849890889, "point": [309.54953749286943, 268.0850517036387, 0] },
                                    { "partialLength": 0.3089303686562902, "point": [309.5544441477182, 267.7761603029551, 0] },
                                    { "partialLength": 0.3159588677849822, "point": [309.5594621289506, 267.4602412848566, 0] },
                                    { "partialLength": 0.3228730823753656, "point": [309.5645896263818, 267.137408919545, 0] },
                                    { "partialLength": 0.329673012427235, "point": [309.56982482982664, 266.8077774772223, 0] },
                                    { "partialLength": 0.33635865794067515, "point": [309.57516592909985, 266.47146122809033, 0] },
                                    { "partialLength": 0.3429300189158376, "point": [309.5806111140165, 266.1285744423507, 0] },
                                    { "partialLength": 0.34938709535207346, "point": [309.58615857439156, 265.7792313902058, 0] },
                                    { "partialLength": 0.3557298872499845, "point": [309.59180650003975, 265.42354634185716, 0] },
                                    { "partialLength": 0.36195839460949975, "point": [309.59755308077604, 265.0616335675066, 0] },
                                    { "partialLength": 0.3680726174302031, "point": [309.60339650641527, 264.6936073373562, 0] },
                                    { "partialLength": 0.3740725557125374, "point": [309.60933496677245, 264.3195819216076, 0] },
                                    { "partialLength": 0.3799582094560876, "point": [309.6153666516624, 263.9396715904629, 0] },
                                    { "partialLength": 0.3857295786612422, "point": [309.6214897509, 263.5539906141238, 0] },
                                    { "partialLength": 0.3913866633277048, "point": [309.6277024543003, 263.16265326279216, 0] },
                                    { "partialLength": 0.3969294634554624, "point": [309.63400295167787, 262.76577380667, 0] },
                                    { "partialLength": 0.4023579790446843, "point": [309.64038943284805, 262.36346651595903, 0] },
                                    { "partialLength": 0.4076722100953492, "point": [309.64686008762527, 261.9558456608611, 0] },
                                    { "partialLength": 0.41287215660700793, "point": [309.6534131058248, 261.5430255115784, 0] },
                                    { "partialLength": 0.41795781858043723, "point": [309.6600466772613, 261.12512033831234, 0] },
                                    { "partialLength": 0.4229291960149581, "point": [309.6667589917498, 260.7022444112651, 0] },
                                    { "partialLength": 0.4277862889109, "point": [309.6735482391053, 260.2745120006384, 0] },
                                    { "partialLength": 0.4325290972680838, "point": [309.68041260914237, 259.84203737663427, 0] },
                                    { "partialLength": 0.4371576210866829, "point": [309.68735029167624, 259.4049348094544, 0] },
                                    { "partialLength": 0.44167186036651357, "point": [309.6943594765216, 258.9633185693008, 0] },
                                    { "partialLength": 0.4460718151076894, "point": [309.70143835349336, 258.51730292637524, 0] },
                                    { "partialLength": 0.4503574853102621, "point": [309.70858511240647, 258.06700215087955, 0] },
                                    { "partialLength": 0.4545288709738893, "point": [309.715797943076, 257.6125305130158, 0] },
                                    { "partialLength": 0.4585859720991834, "point": [309.7230750353164, 257.1540022829856, 0] },
                                    { "partialLength": 0.46252878868535796, "point": [309.73041457894305, 256.6915317309911, 0] },
                                    { "partialLength": 0.4663573207331937, "point": [309.7378147637705, 256.2252331272338, 0] },
                                    { "partialLength": 0.4700715682421008, "point": [309.74527377961385, 255.7552207419159, 0] },
                                    { "partialLength": 0.4736715312123258, "point": [309.752789816288, 255.28160884523916, 0] },
                                    { "partialLength": 0.4771572096438376, "point": [309.76036106360766, 254.80451170740545, 0] },
                                    { "partialLength": 0.48052860353675214, "point": [309.76798571138795, 254.32404359861653, 0] },
                                    { "partialLength": 0.48378571289074984, "point": [309.77566194944364, 253.84031878907444, 0] },
                                    { "partialLength": 0.4869285377061697, "point": [309.78338796758953, 253.35345154898093, 0] },
                                    { "partialLength": 0.48995707798281607, "point": [309.79116195564075, 252.8635561485379, 0] },
                                    { "partialLength": 0.4928713337205415, "point": [309.7989821034122, 252.3707468579474, 0] },
                                    { "partialLength": 0.4956713049199924, "point": [309.8068466007184, 251.87513794741088, 0] },
                                    { "partialLength": 0.49835699158024105, "point": [309.81475363737474, 251.37684368713064, 0] },
                                    { "partialLength": 0.5009283937020984, "point": [309.8227014031957, 250.87597834730823, 0] },
                                    { "partialLength": 0.5033855112849477, "point": [309.8306880879965, 250.3726561981458, 0] },
                                    { "partialLength": 0.5057283443292918, "point": [309.8387118815919, 249.86699150984495, 0] },
                                    { "partialLength": 0.5079568928348189, "point": [309.8467709737967, 249.35909855260766, 0] },
                                    { "partialLength": 0.5100711568015314, "point": [309.854863554426, 248.84909159663587, 0] },
                                    { "partialLength": 0.5120711362296235, "point": [309.86298781329464, 248.33708491213133, 0] },
                                    { "partialLength": 0.5139568311188651, "point": [309.87114194021734, 247.823192769296, 0] },
                                    { "partialLength": 0.5157282414694311, "point": [309.8793241250092, 247.30752943833173, 0] },
                                    { "partialLength": 0.5173853672812044, "point": [309.8875325574851, 246.7902091894404, 0] },
                                    { "partialLength": 0.5189282085544079, "point": [309.8957654274597, 246.2713462928237, 0] },
                                    { "partialLength": 0.5203567652885669, "point": [309.9040209247483, 245.75105501868381, 0] },
                                    { "partialLength": 0.5216710374842666, "point": [309.9122972391654, 245.22944963722233, 0] },
                                    { "partialLength": 0.5228710251410038, "point": [309.9205925605262, 244.70664441864133, 0] },
                                    { "partialLength": 0.5239567282592275, "point": [309.9289050786454, 244.18275363314245, 0] },
                                    { "partialLength": 0.5249281468385126, "point": [309.937232983338, 243.65789155092776, 0] },
                                    { "partialLength": 0.5257852808791154, "point": [309.9455744644189, 243.13217244219905, 0] },
                                    { "partialLength": 0.5265281303809201, "point": [309.95392771170293, 242.60571057715825, 0] },
                                    { "partialLength": 0.5271566953440691, "point": [309.96229091500504, 242.07862022600713, 0] },
                                    { "partialLength": 0.5276709757684488, "point": [309.9706622641401, 241.5510156589476, 0] },
                                    { "partialLength": 0.5280709716540304, "point": [309.97903994892306, 241.02301114618155, 0] },
                                    { "partialLength": 0.5283566830010108, "point": [309.98742215916866, 240.49472095791072, 0] },
                                    { "partialLength": 0.5285281098089408, "point": [309.99580708469205, 239.96625936433728, 0] },
                                    { "partialLength": 0.528585252078439, "point": [310.00419291530795, 239.43774063566278, 0] },
                                    { "partialLength": 0.5285281098090535, "point": [310.0125778408313, 238.90927904208922, 0] },
                                    { "partialLength": 0.5283566830009265, "point": [310.02096005107694, 238.38098885381848, 0] },
                                    { "partialLength": 0.5280709716540304, "point": [310.0293377358599, 237.85298434105243, 0] },
                                    { "partialLength": 0.5276709757684771, "point": [310.03770908499496, 237.32537977399286, 0] },
                                    { "partialLength": 0.5271566953440407, "point": [310.04607228829707, 236.79828942284178, 0] },
                                    { "partialLength": 0.5265281303809769, "point": [310.0544255355811, 236.27182755780092, 0] },
                                    { "partialLength": 0.525785280879086, "point": [310.06276701666195, 235.74610844907224, 0] },
                                    { "partialLength": 0.5249281468385144, "point": [310.07109492135464, 235.22124636685754, 0] },
                                    { "partialLength": 0.5239567282591423, "point": [310.07940743947387, 234.69735558135875, 0] },
                                    { "partialLength": 0.5228710251410882, "point": [310.0877027608346, 234.17455036277767, 0] },
                                    { "partialLength": 0.521671037484239, "point": [310.09597907525176, 233.6529449813162, 0] },
                                    { "partialLength": 0.5203567652886512, "point": [310.1042345725403, 233.13265370717625, 0] },
                                    { "partialLength": 0.5189282085543245, "point": [310.112467442515, 232.61379081055964, 0] },
                                    { "partialLength": 0.5173853672812319, "point": [310.12067587499087, 232.09647056166827, 0] },
                                    { "partialLength": 0.5157282414694595, "point": [310.1288580597827, 231.58080723070395, 0] },
                                    { "partialLength": 0.5139568311188651, "point": [310.1370121867054, 231.06691508786864, 0] },
                                    { "partialLength": 0.5120711362295658, "point": [310.145136445574, 230.55490840336415, 0] },
                                    { "partialLength": 0.5100711568015599, "point": [310.1532290262033, 230.04490144739233, 0] },
                                    { "partialLength": 0.5079568928347905, "point": [310.1612881184081, 229.53700849015507, 0] },
                                    { "partialLength": 0.5057283443292918, "point": [310.1693119120035, 229.03134380185423, 0] },
                                    { "partialLength": 0.5033855112849751, "point": [310.17729859680423, 228.52802165269176, 0] },
                                    { "partialLength": 0.5009283937020149, "point": [310.1852463626253, 228.02715631286944, 0] },
                                    { "partialLength": 0.49835699158035385, "point": [310.1931533992816, 227.5288620525891, 0] },
                                    { "partialLength": 0.49567130491987965, "point": [310.20101789658787, 227.03325314205267, 0] },
                                    { "partialLength": 0.4928713337206827, "point": [310.20883804435925, 226.54044385146204, 0] },
                                    { "partialLength": 0.48995707798278676, "point": [310.2166120324104, 226.05054845101904, 0] },
                                    { "partialLength": 0.4869285377061431, "point": [310.2243380505564, 225.56368121092555, 0] },
                                    { "partialLength": 0.48378571289077826, "point": [310.2320142886121, 225.07995640138344, 0] },
                                    { "partialLength": 0.48052860353663757, "point": [310.23963893639234, 224.59948829259463, 0] },
                                    { "partialLength": 0.47715720964389446, "point": [310.247210183712, 224.12239115476086, 0] },
                                    { "partialLength": 0.4736715312123542, "point": [310.25472622038615, 223.6487792580841, 0] },
                                    { "partialLength": 0.4700715682421008, "point": [310.2621852362295, 223.17876687276618, 0] },
                                    { "partialLength": 0.4663573207331378, "point": [310.269585421057, 222.71246826900898, 0] },
                                    { "partialLength": 0.46252878868546987, "point": [310.27692496468353, 222.24999771701437, 0] },
                                    { "partialLength": 0.45858597209907154, "point": [310.2842020569241, 221.79146948698423, 0] },
                                    { "partialLength": 0.4545288709739736, "point": [310.29141488759353, 221.33699784912042, 0] },
                                    { "partialLength": 0.4503574853102337, "point": [310.29856164650664, 220.88669707362476, 0] },
                                    { "partialLength": 0.44607181510771876, "point": [310.3056405234785, 220.4406814306992, 0] },
                                    { "partialLength": 0.44167186036651357, "point": [310.3126497083238, 219.99906519054556, 0] },
                                    { "partialLength": 0.43715762108665357, "point": [310.31958739085763, 219.56196262336573, 0] },
                                    { "partialLength": 0.4325290972681416, "point": [310.32645176089477, 219.12948799936152, 0] },
                                    { "partialLength": 0.4277862889108698, "point": [310.3332410082501, 218.70175558873487, 0] },
                                    { "partialLength": 0.4229291960149297, "point": [310.33995332273867, 218.27887966168765, 0] },
                                    { "partialLength": 0.4179578185803813, "point": [310.3465868941752, 217.86097448842168, 0] },
                                    { "partialLength": 0.41287215660712073, "point": [310.3531399123747, 217.44815433913885, 0] },
                                    { "partialLength": 0.40767221009523824, "point": [310.35961056715206, 217.04053348404102, 0] },
                                    { "partialLength": 0.4023579790446825, "point": [310.36599704832213, 216.63822619333007, 0] },
                                    { "partialLength": 0.3969294634555201, "point": [310.3722975456998, 216.24134673720783, 0] },
                                    { "partialLength": 0.3913866633276461, "point": [310.3785102490999, 215.85000938587626, 0] },
                                    { "partialLength": 0.38572957866121466, "point": [310.3846333483376, 215.46432840953716, 0] },
                                    { "partialLength": 0.37995820945617287, "point": [310.39066503322755, 215.0844180783924, 0] },
                                    { "partialLength": 0.3740725557125374, "point": [310.39660349358473, 214.7103926626438, 0] },
                                    { "partialLength": 0.36807261743025993, "point": [310.40244691922396, 214.34236643249335, 0] },
                                    { "partialLength": 0.3619583946094145, "point": [310.40819349996025, 213.98045365814286, 0] },
                                    { "partialLength": 0.35572988725006977, "point": [310.41384142560844, 213.62476860979416, 0] },
                                    { "partialLength": 0.3493870953521294, "point": [310.41938888598344, 213.27542555764916, 0] },
                                    { "partialLength": 0.342930018915668, "point": [310.42483407090015, 212.93253877190972, 0] },
                                    { "partialLength": 0.33635865794070446, "point": [310.4301751701734, 212.5962225227777, 0] },
                                    { "partialLength": 0.3296730124272625, "point": [310.4354103736182, 212.266591080455, 0] },
                                    { "partialLength": 0.3228730823753372, "point": [310.4405378710494, 211.94375871514345, 0] },
                                    { "partialLength": 0.3159588677850124, "point": [310.4455558522819, 211.62783969704492, 0] },
                                    { "partialLength": 0.30893036865625995, "point": [310.45046250713057, 211.3189482963613, 0] },
                                    { "partialLength": 0.30178758498920166, "point": [310.4552560254103, 211.0171987832944, 0] },
                                    { "partialLength": 0.29453051678364933, "point": [310.4599345969361, 210.72270542804623, 0] },
                                    { "partialLength": 0.2871591640400111, "point": [310.4644964115227, 210.43558250081847, 0] },
                                    { "partialLength": 0.2796735267579974, "point": [310.46893965898505, 210.15594427181313, 0] },
                                    { "partialLength": 0.27207360493786464, "point": [310.47326252913814, 209.883905011232, 0] },
                                    { "partialLength": 0.26435939857953145, "point": [310.4774632117968, 209.61957898927704, 0] },
                                    { "partialLength": 0.2565309076832696, "point": [310.4815398967759, 209.36308047615, 0] },
                                    { "partialLength": 0.24858813224896498, "point": [310.4854907738904, 209.11452374205282, 0] },
                                    { "partialLength": 0.24053107227677276, "point": [310.4893140329551, 208.8740230571874, 0] },
                                    { "partialLength": 0.23235972776691904, "point": [310.49300786378507, 208.6416926917555, 0] },
                                    { "partialLength": 0.2240740987193371, "point": [310.49657045619506, 208.41764691595912, 0] },
                                    { "partialLength": 0.21567418513441217, "point": [310.5, 208.202, 0] }
                                ]
                            }
                        },
                        { "t": 20, "s": [310.5, 208.202, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [86.75, 15.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [80.451, 15],
                                        [-72.99, 15],
                                        [-86.5, 8.951],
                                        [-86.5, -1.49],
                                        [-80.451, -15],
                                        [72.99, -15],
                                        [86.5, -8.951],
                                        [86.5, 1.49]
                                    ],
                                    "o": [
                                        [72.99, 15],
                                        [-80.451, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -8.951],
                                        [-72.99, -15],
                                        [80.451, -15],
                                        [86.5, -1.49],
                                        [86.5, 8.951]
                                    ],
                                    "v": [
                                        [72.99, 15],
                                        [-72.99, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -1.49],
                                        [-72.99, -15],
                                        [72.99, -15],
                                        [86.5, -1.49],
                                        [86.5, 1.49]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.5412, 0.8353, 0.7608, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [86.75, 15.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "state 4 bullet",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 0, "s": [0], "__fnct": [null] },
                        { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 13.334, "s": [0], "__fnct": [null] },
                        { "t": 26.666015625, "s": [100] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [179.53, 271.437, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [17.014, 17.015, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [16.765, -9.259],
                                        [9.258000000000001, 16.765],
                                        [-16.765, 9.259],
                                        [-9.26, -16.765]
                                    ],
                                    "o": [
                                        [16.765, 9.259],
                                        [-9.26, 16.765],
                                        [-16.765, -9.259],
                                        [9.258000000000001, -16.765]
                                    ],
                                    "v": [
                                        [16.765, 0],
                                        [-0.001, 16.765],
                                        [-16.765, 0],
                                        [-0.001, -16.765]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.5412, 0.8353, 0.7608, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [17.014, 17.015], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "list 4",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [-28.631] }, "o": { "x": [0.333], "y": [0] }, "t": 0, "s": [0], "__fnct": [null] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0.296] }, "t": 13.334, "s": [0], "__fnct": [null] },
                        { "t": 26.666015625, "s": [100] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [309.5, 271.202, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [86.75, 15.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [78.951, 16.5],
                                        [-72.99, 15],
                                        [-86.5, 8.951],
                                        [-86.5, -1.49],
                                        [-80.451, -15],
                                        [71.49, -13.5],
                                        [85, -7.4510000000000005],
                                        [85, 2.99]
                                    ],
                                    "o": [
                                        [71.49, 16.5],
                                        [-80.451, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -8.951],
                                        [-72.99, -15],
                                        [78.951, -13.5],
                                        [85, 0.01],
                                        [85, 10.451]
                                    ],
                                    "v": [
                                        [71.49, 16.5],
                                        [-72.99, 15],
                                        [-86.5, 1.49],
                                        [-86.5, -1.49],
                                        [-72.99, -15],
                                        [71.49, -13.5],
                                        [85, 0.01],
                                        [85, 2.99]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.5412, 0.8353, 0.7608, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [86.75, 15.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "white page Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [281, 260.202, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [153.25, 178.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [144.046, -178],
                                        [-133, -178],
                                        [-153, -169.046],
                                        [-153, 158],
                                        [-144.046, 178],
                                        [133, 178],
                                        [153, 169.046],
                                        [153, -158]
                                    ],
                                    "o": [
                                        [133, -178],
                                        [-144.046, -178],
                                        [-153, -158],
                                        [-153, 169.046],
                                        [-133, 178],
                                        [144.046, 178],
                                        [153, 158],
                                        [153, -169.046]
                                    ],
                                    "v": [
                                        [133, -178],
                                        [-133, -178],
                                        [-153, -158],
                                        [-153, 158],
                                        [-133, 178],
                                        [133, 178],
                                        [153, 158],
                                        [153, -158]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ind": 1,
                            "ty": "sh",
                            "ix": 2,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [133, -177.073],
                                        [152.073, -168.517],
                                        [152.073, 158],
                                        [143.517, 177.073],
                                        [-133, 177.073],
                                        [-152.073, 168.517],
                                        [-152.073, -158],
                                        [-143.517, -177.073]
                                    ],
                                    "o": [
                                        [143.517, -177.073],
                                        [152.073, -158],
                                        [152.073, 168.517],
                                        [133, 177.073],
                                        [-143.517, 177.073],
                                        [-152.073, 158],
                                        [-152.073, -168.517],
                                        [-133, -177.073]
                                    ],
                                    "v": [
                                        [133, -177.073],
                                        [152.073, -158],
                                        [152.073, 158],
                                        [133, 177.073],
                                        [-133, 177.073],
                                        [-152.073, 158],
                                        [-152.073, -158],
                                        [-133, -177.073]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 2",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false, "_render": true },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [153.25, 178.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [-133, 177.537],
                                        [-152.537, 168.773],
                                        [-152.537, -157.999],
                                        [-143.772, -177.536],
                                        [133, -177.536],
                                        [152.536, -168.772],
                                        [152.536, 158.001],
                                        [143.772, 177.537]
                                    ],
                                    "o": [
                                        [-143.772, 177.537],
                                        [-152.537, 158.001],
                                        [-152.537, -168.772],
                                        [-133, -177.536],
                                        [143.772, -177.536],
                                        [152.536, -157.999],
                                        [152.536, 168.773],
                                        [133, 177.537]
                                    ],
                                    "v": [
                                        [-133, 177.537],
                                        [-152.537, 158.001],
                                        [-152.537, -157.999],
                                        [-133, -177.536],
                                        [133, -177.536],
                                        [152.536, -157.999],
                                        [152.536, 158.001],
                                        [133, 177.537]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [153.25, 178.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 13,
            "ty": 4,
            "nm": "color page Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [226, 230.202, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [153.25, 178.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [144.046, 178],
                                        [-133, 178],
                                        [-153, 169.046],
                                        [-153, -158],
                                        [-144.046, -178],
                                        [133, -178],
                                        [153, -169.046],
                                        [153, 158]
                                    ],
                                    "o": [
                                        [133, 178],
                                        [-144.046, 178],
                                        [-153, 158],
                                        [-153, -169.046],
                                        [-133, -178],
                                        [144.046, -178],
                                        [153, -158],
                                        [153, 169.046]
                                    ],
                                    "v": [
                                        [133, 178],
                                        [-133, 178],
                                        [-153, 158],
                                        [-153, -158],
                                        [-133, -178],
                                        [133, -178],
                                        [153, -158],
                                        [153, 158]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.0392, 0.0941, 0.4, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [153.25, 178.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 100,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        }
    ],
    "markers": [],
    "__complete": true
}
